import React, { useEffect, useRef, useState } from "react";
import Resizer from "react-image-file-resizer";
import { IconButton, Tooltip } from "@mui/material";
import SmilySVG from "./../assets/teeth_profile/AvatarSmily.svg";
import BuccalLeftSVG from "./../assets/teeth_profile/BuccalLeft.svg";
import FrontToothSVG from "./../assets/teeth_profile/FrontTooth.svg";
import BuccalRightSVG from "./../assets/teeth_profile/BuccalRight.svg";
import OcclusalUpperSVG from "./../assets/teeth_profile/OcclusalUpper.svg";
import OcclusalLowerSVG from "./../assets/teeth_profile/OcclusalLower.svg";
import LeftAligner from "./../assets/left_aligner.png";
import { ReactComponent as ChevronRightIcon } from "./../assets/chevron_right.svg";
import { ReactComponent as ClockIcon } from "./../assets/clock.svg";
import { ImArrowDown } from "react-icons/im";
import {
  CHECK_ICON_COLOR,
  DESCRIPTION_COLOR,
  PRIMARY_COLOR,
  TEXT_COLOR,
} from "../constants/theme";
import { ReactComponent as PlusIconPrimary } from "./../assets/plus_icon_primary.svg";
import { FaCircleCheck } from "react-icons/fa6";
import { CiCamera } from "react-icons/ci";
import { IoCloudUploadOutline } from "react-icons/io5";
import Loader from "../components/Loader";
import { updateAlignerSchedulePictures } from "../services/alignerSchedule/alignerSchedule.service";
import { toast } from "react-toastify";
import moment from "moment";

const SwitchAlignersScreen = () => {
  const switchDetails = JSON.parse(sessionStorage.getItem("switchData"));
  const step = switchDetails?.step;
  const alignerData = switchDetails?.alignerSchedule;
  const alignerScheduleId = alignerData?.aligner_schedule_id;
  const alignerMax = Math.max(
    alignerData?.aligners_lower_quantity,
    alignerData?.aligners_upper_quantity
  );
  const email = sessionStorage.getItem("email");
  const caseHistory = sessionStorage.getItem("caseHistory")
    ? JSON.parse(sessionStorage.getItem("caseHistory"))
    : [];
  const [switchedAligner, setSwitchedAligner] = useState(true);
  const [beforeSmilyPic, setBeforeSmilyPic] = useState("");
  const [beforeFrontToothPic, setBeforeFrontToothPic] = useState("");
  const [beforeBuccalLeftPic, setBeforeBuccalLeftPic] = useState("");
  const [beforeBuccalRightPic, setBeforeBuccalRightPic] = useState("");
  const [beforeOcclusalUpperPic, setBeforeOcclusalUpperPic] = useState("");
  const [beforeOcclusalLowerPic, setBeforeOcclusalLowerPic] = useState("");

  const [afterSmilyPic, setAfterSmilyPic] = useState("");
  const [afterFrontToothPic, setAfterFrontToothPic] = useState("");
  const [afterBuccalLeftPic, setAfterBuccalLeftPic] = useState("");
  const [afterBuccalRightPic, setAfterBuccalRightPic] = useState("");
  const [afterOcclusalUpperPic, setAfterOcclusalUpperPic] = useState("");
  const [afterOcclusalLowerPic, setAfterOcclusalLowerPic] = useState("");

  const [beforeSmilyFile, setBeforeSmilyFile] = useState();
  const [beforeFrontToothFile, setBeforeFrontToothFile] = useState();
  const [beforeBuccalLeftFile, setBeforeBuccalLeftFile] = useState();
  const [beforeBuccalRightFile, setBeforeBuccalRightFile] = useState();
  const [beforeOcclusalLowerFile, setBeforeOcclusalLowerFile] = useState();
  const [beforeOcclusalUpperFile, setBeforeOcclusalUpperFile] = useState();

  const [afterSmilyFile, setAfterSmilyFile] = useState();
  const [afterFrontToothFile, setAfterFrontToothFile] = useState();
  const [afterBuccalLeftFile, setAfterBuccalLeftFile] = useState();
  const [afterBuccalRightFile, setAfterBuccalRightFile] = useState();
  const [afterOcclusalLowerFile, setAfterOcclusalLowerFile] = useState();
  const [afterOcclusalUpperFile, setAfterOcclusalUpperFile] = useState();

  const [loading, setLoading] = useState(false);

  const [isHovered, setIsHovered] = useState([
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
  ]);

  const [isHoveredReset, setIsHoveredReset] = useState([
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
  ]);

  const [webCamStatusReset, setWebCamStatusReset] = useState([
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
  ]);
  const [webCamStatus, setWebCamStatus] = useState([
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
  ]);

  const [imageUploadLoading, setImageUploadLoading] = useState([
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
  ]);

  const [useFrontCamera, setUseFrontCamera] = useState({
    beforesmily: false,
    aftersmily: false,
    beforefronttooth: false,
    afterfronttooth: false,
    beforebuccalleft: false,
    afterbuccalleft: false,
    beforebuccalright: false,
    afterbuccalright: false,
    beforeocclusalupper: false,
    afterocclusalupper: false,
    beforeocclusallower: false,
    afterocclusallower: false,
  });

  const [screenWidth, setScreenWidth] = useState(0);

  const inputRefBeforeSmily = useRef(null);
  const inputRefBeforeFrontToothPic = useRef(null);
  const inputRefBeforeBuccalLeftPic = useRef(null);
  const inputRefBeforeBuccalRightPic = useRef(null);
  const inputRefBeforeOcclusalUpperPic = useRef(null);
  const inputRefBeforeOcclusalLowerPic = useRef(null);

  const inputRefAfterSmily = useRef(null);
  const inputRefAfterFrontToothPic = useRef(null);
  const inputRefAfterBuccalLeftPic = useRef(null);
  const inputRefAfterBuccalRightPic = useRef(null);
  const inputRefAfterOcclusalUpperPic = useRef(null);
  const inputRefAfterOcclusalLowerPic = useRef(null);

  const camRef = useRef({});
  const canvasRef = useRef({});

  const constraints = {
    video: {
      width: {
        min: 110,
        ideal: 115,
        max: 170,
      },
      height: {
        min: 80,
        ideal: 110,
        max: 170,
      },
    },
  };

  useEffect(() => {
    const resizeWindow = () => {
      setScreenWidth(window?.outerWidth);
    };

    window?.addEventListener("resize", resizeWindow);

    resizeWindow();

    return () => {
      window.removeEventListener("resize", resizeWindow);
    };
  }, []);

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (imageUploadLoading.find((item) => item == true)) {
        event.preventDefault();
        event.returnValue = "";
      } else {
        window.onbeforeunload = null;
      }
    };

    if (imageUploadLoading.find((item) => item == true)) {
      window.addEventListener("beforeunload", handleBeforeUnload);
    } else {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    }

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [imageUploadLoading]);

  useEffect(() => {
    beforeSmilyFile && UploadImages("beforesmily");
  }, [beforeSmilyFile]);

  useEffect(() => {
    afterSmilyFile && UploadImages("aftersmily");
  }, [afterSmilyFile]);

  useEffect(() => {
    beforeFrontToothFile && UploadImages("beforefronttooth");
  }, [beforeFrontToothFile]);

  useEffect(() => {
    afterFrontToothFile && UploadImages("afterfronttooth");
  }, [afterFrontToothFile]);

  useEffect(() => {
    beforeBuccalLeftFile && UploadImages("beforebuccalleft");
  }, [beforeBuccalLeftFile]);

  useEffect(() => {
    afterBuccalLeftFile && UploadImages("afterbuccalleft");
  }, [afterBuccalLeftFile]);

  useEffect(() => {
    beforeBuccalRightFile && UploadImages("beforebuccalright");
  }, [beforeBuccalRightFile]);

  useEffect(() => {
    afterBuccalRightFile && UploadImages("afterbuccalright");
  }, [afterBuccalRightFile]);

  useEffect(() => {
    beforeOcclusalLowerFile && UploadImages("beforeocclusalupper");
  }, [beforeOcclusalLowerFile]);

  useEffect(() => {
    afterOcclusalLowerFile && UploadImages("afterocclusalupper");
  }, [afterOcclusalLowerFile]);

  useEffect(() => {
    beforeOcclusalUpperFile && UploadImages("beforeocclusallower");
  }, [beforeOcclusalUpperFile]);

  useEffect(() => {
    afterOcclusalUpperFile && UploadImages("afterocclusallower");
  }, [afterOcclusalUpperFile]);

  const resizeFile = (file) =>
    new Promise((resolve) => {
      Resizer.imageFileResizer(
        file,
        1280,
        720,
        "WEBP",
        100,
        0,
        (uri) => {
          resolve(uri);
        },
        "base64"
      );
    });

  const convertToFile = async (value, name) => {
    const blob = await fetch(value).then((res) => res.blob());
    const type = "image/webp";
    const file = new File([blob], name, { type });

    if (name == "beforesmily") {
      setBeforeSmilyFile(file);
    } else if (name == "aftersmily") {
      setAfterSmilyFile(file);
    } else if (name == "beforefronttooth") {
      setBeforeFrontToothFile(file);
    } else if (name == "afterfronttooth") {
      setAfterFrontToothFile(file);
    } else if (name == "beforebuccalleft") {
      setBeforeBuccalLeftFile(file);
    } else if (name == "afterbuccalleft") {
      setAfterBuccalLeftFile(file);
    } else if (name == "beforebuccalright") {
      setBeforeBuccalRightFile(file);
    } else if (name == "afterbuccalright") {
      setAfterBuccalRightFile(file);
    } else if (name == "beforeocclusalupper") {
      setBeforeOcclusalUpperFile(file);
    } else if (name == "afterocclusalupper") {
      setAfterOcclusalUpperFile(file);
    } else if (name == "beforeocclusallower") {
      setBeforeOcclusalLowerFile(file);
    } else if (name == "afterocclusallower") {
      setAfterOcclusalLowerFile(file);
    }
  };

  const handleMouseEnter = (index) => {
    let temp = [...isHoveredReset];
    temp[index] = true;
    setIsHovered([...temp]);
  };

  const handleMouseLeave = (index) => {
    let temp = [...isHoveredReset];
    temp[index] = false;
    setIsHovered([...temp]);
  };

  const handleDrop = async (e) => {
    e.preventDefault();
    let imageData = await resizeFile(e.dataTransfer.files[0]);
    convertToFile(imageData, e.target.id);

    if (e.target.id == "beforesmily") {
      setBeforeSmilyPic(imageData);
    } else if (e.target.id == "aftersmily") {
      setAfterSmilyPic(imageData);
    } else if (e.target.id == "beforefronttooth") {
      setBeforeFrontToothPic(imageData);
    } else if (e.target.id == "afterfronttooth") {
      setAfterFrontToothPic(imageData);
    } else if (e.target.id == "beforebuccalleft") {
      setBeforeBuccalLeftPic(imageData);
    } else if (e.target.id == "afterbuccalleft") {
      setAfterBuccalLeftPic(imageData);
    } else if (e.target.id == "beforebuccalright") {
      setBeforeBuccalRightPic(imageData);
    } else if (e.target.id == "afterbuccalright") {
      setAfterBuccalRightPic(imageData);
    } else if (e.target.id == "beforeocclusalupper") {
      setBeforeOcclusalUpperPic(imageData);
    } else if (e.target.id == "afterocclusalupper") {
      setAfterOcclusalUpperPic(imageData);
    } else if (e.target.id == "beforeocclusallower") {
      setBeforeOcclusalLowerPic(imageData);
    } else if (e.target.id == "afterocclusallower") {
      setAfterOcclusalLowerPic(imageData);
    }
    setIsHovered([...isHoveredReset]);
  };

  const handleImageUpload = async (e) => {
    let imageData = await resizeFile(e.target.files[0]);
    await convertToFile(imageData, e.target.id);

    setIsHovered([...isHoveredReset]);
    if (e.target.id == "beforesmily") {
      setBeforeSmilyPic(imageData);
    } else if (e.target.id == "aftersmily") {
      setAfterSmilyPic(imageData);
    } else if (e.target.id == "beforefronttooth") {
      setBeforeFrontToothPic(imageData);
    } else if (e.target.id == "afterfronttooth") {
      setAfterFrontToothPic(imageData);
    } else if (e.target.id == "beforebuccalleft") {
      setBeforeBuccalLeftPic(imageData);
    } else if (e.target.id == "afterbuccalleft") {
      setAfterBuccalLeftPic(imageData);
    } else if (e.target.id == "beforebuccalright") {
      setBeforeBuccalRightPic(imageData);
    } else if (e.target.id == "afterbuccalright") {
      setAfterBuccalRightPic(imageData);
    } else if (e.target.id == "beforeocclusalupper") {
      setBeforeOcclusalUpperPic(imageData);
    } else if (e.target.id == "afterocclusalupper") {
      setAfterOcclusalUpperPic(imageData);
    } else if (e.target.id == "beforeocclusallower") {
      setBeforeOcclusalLowerPic(imageData);
    } else if (e.target.id == "afterocclusallower") {
      setAfterOcclusalLowerPic(imageData);
    }
  };

  const initializeCamera = async (value, index, camera = false) => {
    Object.keys(camRef.current)?.forEach((item) => {
      camRef.current[item]?.srcObject?.getTracks()?.forEach((track) => {
        track.stop();
      });
    });
    let temp = [...webCamStatusReset];
    temp[index] = true;
    setWebCamStatus([...temp]);
    constraints.video.facingMode = camera ? "user" : "environment";

    try {
      const stream = await navigator.mediaDevices.getUserMedia(constraints);
      if (value == "beforesmily") {
        if (camRef.current["beforesmily"]) {
          camRef.current["beforesmily"].srcObject = stream;
        }
      } else if (value == "aftersmily") {
        if (camRef.current["aftersmily"]) {
          camRef.current["aftersmily"].srcObject = stream;
        }
      } else if (value == "beforefronttooth") {
        if (camRef.current["beforefronttooth"]) {
          camRef.current["beforefronttooth"].srcObject = stream;
        }
      } else if (value == "afterfronttooth") {
        if (camRef.current["afterfronttooth"]) {
          camRef.current["afterfronttooth"].srcObject = stream;
        }
      } else if (value == "beforebuccalleft") {
        if (camRef.current["beforebuccalleft"]) {
          camRef.current["beforebuccalleft"].srcObject = stream;
        }
      } else if (value == "afterbuccalleft") {
        if (camRef.current["afterbuccalleft"]) {
          camRef.current["afterbuccalleft"].srcObject = stream;
        }
      } else if (value == "beforebuccalright") {
        if (camRef.current["beforebuccalright"]) {
          camRef.current["beforebuccalright"].srcObject = stream;
        }
      } else if (value == "afterbuccalright") {
        if (camRef.current["afterbuccalright"]) {
          camRef.current["afterbuccalright"].srcObject = stream;
        }
      } else if (value == "beforeocclusalupper") {
        if (camRef.current["beforeocclusalupper"]) {
          camRef.current["beforeocclusalupper"].srcObject = stream;
        }
      } else if (value == "afterocclusalupper") {
        if (camRef.current["afterocclusalupper"]) {
          camRef.current["afterocclusalupper"].srcObject = stream;
        }
      } else if (value == "beforeocclusallower") {
        if (camRef.current["beforeocclusallower"]) {
          camRef.current["beforeocclusallower"].srcObject = stream;
        }
      } else if (value == "afterocclusallower") {
        if (camRef.current["afterocclusallower"]) {
          camRef.current["afterocclusallower"].srcObject = stream;
        }
      }
    } catch (err) {
      let temp2 = webCamStatus;
      temp2[index] = false;
      setWebCamStatus([...temp2]);
      console.log("Err", err);
      alert(err);
    }
  };

  const SwitchCamera = (value, index) => {
    let temp = { ...useFrontCamera };
    temp[value] = !useFrontCamera[value];

    setUseFrontCamera({ ...temp });

    initializeCamera(value, index, temp[value]);
  };

  // modify below
  const uploadImpressionImages = async (
    beforesmily,
    aftersmily,
    beforefronttooth,
    afterfronttooth,
    beforebuccalleft,
    afterbuccalleft,
    beforebuccalright,
    afterbuccalright,
    beforeocclusalupper,
    afterocclusalupper,
    beforeocclusallower,
    afterocclusallower,
    setImageUploadLoading,
    imageUploadLoading,
    index
  ) => {
    let data = {
      aligner_schedule_id: alignerScheduleId,
      email,
      before_smily_picture: beforesmily,
      after_smily_picture: aftersmily,
      before_teeth_picture: beforefronttooth,
      after_front_teeth_picture: afterfronttooth,
      before_buccal_left_picture: beforebuccalleft,
      after_buccal_left_picture: afterbuccalleft,
      before_buccal_right_picture: beforebuccalright,
      after_buccal_right_picture: afterbuccalright,
      before_occlusal_upper: beforeocclusalupper,
      after_occlusal_upper: afterocclusalupper,
      before_occlusal_lower: beforeocclusallower,
      after_occlusal_lower: afterocclusallower,
      update_step: step,
    };

    Object.keys(data).forEach(
      (k) => (data[k] === "" || data[k] == undefined) && delete data[k]
    );

    try {
      const response = await updateAlignerSchedulePictures(data);
      if (response?.data.status == 200) {
        let temp = imageUploadLoading;
        temp[index] = false;
        setImageUploadLoading([...temp]);
      } else {
        setLoading(false);
        let temp = imageUploadLoading;
        temp[index] = false;
        setImageUploadLoading([...temp]);
        toast.error(response.data.message);
      }
    } catch (err) {
      setLoading(false);
      let temp = imageUploadLoading;
      temp[index] = false;
      setImageUploadLoading([...temp]);
      if (err.response) {
        toast.error(err.response.data.message?.toString());
      } else if (err.message) {
        toast.error(err.message);
      } else {
        toast.error(err);
      }
    }
  };

  const UploadImages = (value) => {
    if (value == "beforesmily") {
      let temp = imageUploadLoading;
      temp[0] = true;
      setImageUploadLoading([...temp]);
      uploadImpressionImages(
        beforeSmilyFile,
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        setImageUploadLoading,
        imageUploadLoading,
        0
      );
    } else if (value == "aftersmily") {
      let temp = imageUploadLoading;
      temp[1] = true;
      setImageUploadLoading([...temp]);
      uploadImpressionImages(
        "",
        afterSmilyFile,
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        setImageUploadLoading,
        imageUploadLoading,
        1
      );
    } else if (value == "beforefronttooth") {
      let temp = imageUploadLoading;
      temp[2] = true;
      setImageUploadLoading([...temp]);
      uploadImpressionImages(
        "",
        "",
        beforeFrontToothFile,
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        setImageUploadLoading,
        imageUploadLoading,
        2
      );
    } else if (value == "afterfronttooth") {
      let temp = imageUploadLoading;
      temp[3] = true;
      setImageUploadLoading([...temp]);
      uploadImpressionImages(
        "",
        "",
        "",
        afterFrontToothFile,
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        setImageUploadLoading,
        imageUploadLoading,
        3
      );
    } else if (value == "beforebuccalleft") {
      let temp = imageUploadLoading;
      temp[4] = true;
      setImageUploadLoading([...temp]);
      uploadImpressionImages(
        "",
        "",
        "",
        "",
        beforeBuccalLeftFile,
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        setImageUploadLoading,
        imageUploadLoading,
        4
      );
    } else if (value == "afterbuccalleft") {
      let temp = imageUploadLoading;
      temp[5] = true;
      setImageUploadLoading([...temp]);
      uploadImpressionImages(
        "",
        "",
        "",
        "",
        "",
        afterBuccalLeftFile,
        "",
        "",
        "",
        "",
        "",
        "",
        setImageUploadLoading,
        imageUploadLoading,
        5
      );
    } else if (value == "beforebuccalright") {
      let temp = imageUploadLoading;
      temp[6] = true;
      setImageUploadLoading([...temp]);

      uploadImpressionImages(
        "",
        "",
        "",
        "",
        "",
        "",
        beforeBuccalRightFile,
        "",
        "",
        "",
        "",
        "",
        setImageUploadLoading,
        imageUploadLoading,
        6
      );
    } else if (value == "afterbuccalright") {
      let temp = imageUploadLoading;
      temp[7] = true;
      setImageUploadLoading([...temp]);
      uploadImpressionImages(
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        afterBuccalRightFile,
        "",
        "",
        "",
        "",
        setImageUploadLoading,
        imageUploadLoading,
        7
      );
    } else if (value == "beforeocclusalupper") {
      let temp = imageUploadLoading;
      temp[8] = true;
      setImageUploadLoading([...temp]);
      uploadImpressionImages(
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        beforeOcclusalUpperFile,
        "",
        "",
        "",
        setImageUploadLoading,
        imageUploadLoading,
        8
      );
    } else if (value == "afterocclusalupper") {
      let temp = imageUploadLoading;
      temp[9] = true;
      setImageUploadLoading([...temp]);
      uploadImpressionImages(
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        afterOcclusalUpperFile,
        "",
        "",
        setImageUploadLoading,
        imageUploadLoading,
        9
      );
    } else if (value == "beforeocclusallower") {
      let temp = imageUploadLoading;
      temp[10] = true;
      setImageUploadLoading([...temp]);
      uploadImpressionImages(
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        beforeOcclusalLowerFile,
        "",
        setImageUploadLoading,
        imageUploadLoading,
        10
      );
    } else if (value == "afterocclusallower") {
      let temp = imageUploadLoading;
      temp[11] = true;
      setImageUploadLoading([...temp]);
      uploadImpressionImages(
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        afterOcclusalLowerFile,
        setImageUploadLoading,
        imageUploadLoading,
        11
      );
    }
  };

  const stopVideoStream = (value, index) => {
    let temp = { ...useFrontCamera };
    temp[value] = false;
    setUseFrontCamera({ ...temp });

    Object.keys(camRef.current)?.forEach((item) => {
      camRef.current[item]?.srcObject?.getTracks()?.forEach((track) => {
        track.stop();
      });
    });
  };

  return (
    <div
      className="row w-100 mx-auto flex-column align-items-center justify-content-start"
      style={{
        backgroundColor: "rgb(255, 255, 255)",
        borderRadius: "15px",
      }}
    >
      <div
        className=""
        style={{
          padding: "12px 13px 16px 13px",
        }}
      >
        <div
          className="row w-100 mx-auto flex-column justify-content-start align-items-center"
          style={{
            gap: "25px",
          }}
        >
          <div className="col-12 p-0">
            <div
              className="text-center"
              style={{
                fontSize: "18px",
                fontWeight: "400",
                color: PRIMARY_COLOR,
                marginBottom: "10px",
              }}
            >
              Switch Aligners
            </div>

            <div
              className="row w-100 mx-auto flex-column align-items-center justify-content-start"
              style={{
                gap: "18px",
              }}
            >
              {/* TOP SECTION */}
              <div className="col-12 p-0">
                <div className="row w-100 mx-auto align-items-center justify-content-center">
                  {/* LEFT ALIGNER SECTION */}

                  <div className="col p-0">
                    <div className="row w-100 mx-auto align-items-center justify-content-center">
                      <div className="col-auto p-0">
                        <div
                          className="row w-100 mx-auto flex-column align-items-center justify-content-start"
                          style={{
                            gap: "5px",
                          }}
                        >
                          <div className="col-auto p-0">
                            <img
                              className=""
                              src={LeftAligner}
                              alt="left aligner"
                              style={{
                                width: "100px",
                                maxWidth: "100%",
                              }}
                            />
                          </div>
                          <div className="col-auto p-0">
                            <div
                              className="row w-100 mx-auto flex-column align-items-center justify-content-center"
                              style={{
                                gap: "2.5px",
                                paddingLeft: "6px",
                              }}
                            >
                              <div className="col-auto p-0">
                                <div
                                  className="text-center"
                                  style={{
                                    fontSize: "7.5px",
                                    fontWeight: "400",
                                    color: TEXT_COLOR,
                                    lineHeight: "1",
                                  }}
                                >
                                  {switchDetails?.step <= alignerMax
                                    ? "Aligner Number"
                                    : "Retainer Number"}
                                </div>
                              </div>
                              <div className="col-auto p-0">
                                <div
                                  className="text-center"
                                  style={{
                                    fontSize: "13.5px",
                                    fontWeight: "600",
                                    color: TEXT_COLOR,
                                    lineHeight: "1",
                                  }}
                                >
                                  {switchDetails?.step <= alignerMax
                                    ? alignerData?.aligners_upper_quantity >=
                                      switchDetails?.step - 1
                                      ? `${switchDetails?.step - 1} Upper`
                                      : `No Upper Aligner`
                                    : alignerData?.retainer_upper_quantity >=
                                      switchDetails?.step - alignerMax
                                    ? `${
                                        switchDetails?.step - alignerMax
                                      } Upper`
                                    : `No Upper Retainer`}
                                </div>
                              </div>
                              <div
                                className="col-auto p-0"
                                style={{
                                  marginTop: "3px",
                                }}
                              >
                                <div
                                  className="text-center"
                                  style={{
                                    fontSize: "13.5px",
                                    fontWeight: "600",
                                    color: TEXT_COLOR,
                                    lineHeight: "1",
                                  }}
                                >
                                  {switchDetails?.step <= alignerMax
                                    ? alignerData?.aligners_lower_quantity >=
                                      switchDetails?.step - 1
                                      ? `${switchDetails?.step - 1} Lower`
                                      : `No Lower Aligner`
                                    : alignerData?.retainer_lower_quantity >=
                                      switchDetails?.step - alignerMax
                                    ? `${
                                        switchDetails?.step - alignerMax
                                      } Lower`
                                    : `No Lower Retainer`}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* RIGHT CHEVRON ICON */}

                  <div className="col-auto p-0">
                    <div className="row w-100 mx-auto flex-column align-items-center justify-content-center">
                      <div className="col-auto p-0">
                        <ChevronRightIcon
                          style={{
                            width: "36px",
                            transform: "rotate(-90deg)",
                            marginRight: "-3px",
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  {/* RIGHT ALIGNER SECTION */}

                  <div className="col p-0">
                    <div className="row w-100 mx-auto align-items-center justify-content-center">
                      <div className="col-auto p-0">
                        <div
                          className="row w-100 mx-auto flex-column align-items-center justify-content-start"
                          style={{
                            gap: "5px",
                          }}
                        >
                          <div className="col-auto p-0">
                            <img
                              className=""
                              src={LeftAligner}
                              alt="left aligner"
                              style={{
                                width: "100px",
                                maxWidth: "100%",
                                transform: "scale(1, -1) rotate(180deg)",
                              }}
                            />
                          </div>
                          <div className="col-auto p-0">
                            <div
                              className="row w-100 mx-auto flex-column align-items-center justify-content-center"
                              style={{
                                gap: "2.5px",
                                paddingRight: "6px",
                              }}
                            >
                              <div className="col-auto p-0">
                                <div
                                  className="text-center"
                                  style={{
                                    fontSize: "7.5px",
                                    fontWeight: "400",
                                    color: TEXT_COLOR,
                                    lineHeight: "1",
                                  }}
                                >
                                  {switchDetails?.step <= alignerMax
                                    ? "Aligner Number"
                                    : "Retainer Number"}
                                </div>
                              </div>
                              <div className="col-auto p-0">
                                <div
                                  className="text-center"
                                  style={{
                                    fontSize: "13.5px",
                                    fontWeight: "600",
                                    color: TEXT_COLOR,
                                    lineHeight: "1",
                                  }}
                                >
                                  {switchDetails?.step <= alignerMax
                                    ? alignerData?.aligners_upper_quantity >=
                                      switchDetails?.step
                                      ? `${switchDetails?.step} Upper`
                                      : `No Upper Aligner`
                                    : alignerData?.retainer_upper_quantity >=
                                      switchDetails?.step - alignerMax
                                    ? `${
                                        switchDetails?.step - alignerMax
                                      } Upper`
                                    : `No Upper Retainer`}
                                </div>
                              </div>
                              <div
                                className="col-auto p-0"
                                style={{
                                  marginTop: "3px",
                                }}
                              >
                                <div
                                  className="text-center"
                                  style={{
                                    fontSize: "13.5px",
                                    fontWeight: "600",
                                    color: TEXT_COLOR,
                                    lineHeight: "1",
                                  }}
                                >
                                  {switchDetails?.step <= alignerMax
                                    ? alignerData?.aligners_lower_quantity >=
                                      switchDetails?.step
                                      ? `${switchDetails?.step} Lower`
                                      : `No Lower Aligner`
                                    : alignerData?.retainer_lower_quantity >=
                                      switchDetails?.step - alignerMax
                                    ? `${
                                        switchDetails?.step - alignerMax
                                      } Lower`
                                    : `No Lower Retainer`}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="row w-100 mx-auto flex-column align-items-center justify-content-start"
                style={{
                  gap: "58px",
                }}
              >
                <div
                  className="row w-100 mx-auto flex-column align-items-center justify-content-center"
                  style={{
                    gap: "5px",
                  }}
                >
                  <div className="col-auto p-0">
                    <button
                      className="btn w-100 service-btn"
                      style={{
                        padding: "9px 5px",
                        border: switchedAligner
                          ? `1px solid ${PRIMARY_COLOR}`
                          : `1px solid rgb(250, 229, 255)`,
                        backgroundColor: switchedAligner
                          ? "rgb(250, 229, 255)"
                          : "",
                        // border: "1px solid rgb(250, 229, 255)",
                        borderRadius: "20px",
                        lineHeight: "1",
                        minWidth: "185px",
                        transition: "all 0.1s ease-in-out",
                      }}
                      disabled
                      onClick={(e) => {
                        setSwitchedAligner(!switchedAligner);
                        e.target.blur();
                      }}
                    >
                      <div
                        className=""
                        style={{
                          fontSize: "10.5px",
                          color: "rgb(153, 0, 204)",
                          fontWeight: "400",
                          transition: "all 0.1s ease-in-out",
                        }}
                      >
                        I have Switched Aligners
                      </div>
                    </button>
                  </div>

                  {switchedAligner && (
                    <div className="col-auto p-0">
                      <ImArrowDown
                        style={{
                          width: "25px",
                          height: "25px",
                          color: "rgb(242, 242, 242)",
                          // objectFit: 'stretch'
                        }}
                      />
                    </div>
                  )}
                </div>

                {switchedAligner && (
                  <div
                    className="row w-100 mx-auto flex-column align-items-center justify-content-start"
                    style={{
                      gap: "8px",
                    }}
                  >
                    <div
                      className="text-center"
                      style={{ color: PRIMARY_COLOR }}
                    >
                      <h6>Before (Without Aligner)</h6>
                    </div>
                    <div
                      className="row w-100 mx-auto flex-column flex-sm-row align-items-center justify-content-center"
                      style={{
                        rowGap: "15px",
                        maxWidth: "700px",
                      }}
                    >
                      <div
                        style={{
                          display: screenWidth <= 500 ? "flex" : "",
                          flexDirection: screenWidth <= 500 ? "column" : "",
                          alignItems: screenWidth <= 500 ? "center" : "",
                        }}
                        className="col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4 mt-2 position-relative"
                      >
                        <div
                          id="beforesmily"
                          onMouseEnter={() =>
                            !webCamStatus[0] && handleMouseEnter(0)
                          }
                          onMouseLeave={() =>
                            !webCamStatus[0] && handleMouseLeave(0)
                          }
                          onDrop={handleDrop}
                          className={
                            "border justify-content-center align-items-center text-center"
                          }
                          onDragOver={(e) => e.preventDefault()}
                          style={{
                            width: "170px",
                            height: "120px",
                            cursor: "pointer",
                            caretColor: "transparent",
                            background:
                              !beforeSmilyPic &&
                              `url(${SmilySVG}) no-repeat center`,
                          }}
                        >
                          {isHovered[0] && (
                            <div
                              className="position-absolute d-flex flex-column align-items-center justify-content-center"
                              style={{
                                width: "160px",
                                height: "110px",
                                top: "1px",
                                backgroundColor: "rgba(256,256,256,0.8)",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-evenly",
                                  width: "-webkit-fill-available",
                                }}
                              >
                                <CiCamera
                                  size={30}
                                  onClick={() => {
                                    let temp = webCamStatus;
                                    temp[0] = true;
                                    setWebCamStatus([...temp]);
                                    let temp2 = [...isHovered];
                                    temp2[0] = false;
                                    setIsHovered([...temp2]);
                                    initializeCamera("beforeSmilyPic", 0);
                                  }}
                                />
                                <div
                                  style={{
                                    border: "1px solid rgba(0,0,0,0.1)",
                                    position: "absolute",
                                    height: "108%",
                                    top: "0px",
                                  }}
                                ></div>
                                <IoCloudUploadOutline
                                  size={30}
                                  onClick={() => {
                                    let temp = [...isHovered];
                                    temp[0] = false;
                                    setIsHovered([...temp]);
                                    let temp2 = [...webCamStatus];
                                    temp2[0] = false;
                                    setWebCamStatus([...temp2]);

                                    inputRefBeforeSmily?.current?.click();
                                  }}
                                />
                              </div>
                            </div>
                          )}
                          {imageUploadLoading[0] && beforeSmilyPic && (
                            <div
                              className="position-absolute"
                              style={{
                                width: "170px",
                                height: "120px",
                                backgroundColor: "rgba(256,256,256,0.4)",

                                zIndex: 99,
                                top: 0,
                              }}
                            >
                              <div
                                className="position-absolute z-1"
                                style={{ top: 25, left: 65, height: 50 }}
                              >
                                <Loader />
                              </div>
                            </div>
                          )}
                          {
                            <input
                              id="beforesmily"
                              type="file"
                              accept="image/png, image/jpeg"
                              onChange={(event) => handleImageUpload(event)}
                              ref={inputRefBeforeSmily}
                              style={{ display: "none" }}
                            />
                          }
                          {!webCamStatus[0] ? (
                            <img
                              src={beforeSmilyPic || ""}
                              id="beforesmily"
                              style={{
                                width: "auto",
                                height: "auto",
                                maxHeight: "110px",
                                maxWidth: "160px",
                              }}
                              // alt="smily webcam"
                            />
                          ) : (
                            <div>
                              <video
                                ref={(el) =>
                                  (camRef.current["beforesmily"] = el)
                                }
                                autoPlay
                                playsInline
                              />
                              <canvas
                                ref={(el) =>
                                  (canvasRef.current["beforesmily"] = el)
                                }
                                style={{ display: "none" }}
                              />
                            </div>
                          )}
                        </div>

                        {webCamStatus[0] && (
                          <div
                            className="d-flex justify-content-between"
                            style={{ width: "170px" }}
                          >
                            <Tooltip title="Capture">
                              <IconButton
                                onClick={() => {
                                  const canvas =
                                    canvasRef.current["beforesmily"];
                                  canvas.width = 170;
                                  canvas.height = 115;

                                  const context = canvas.getContext("2d");

                                  context.drawImage(
                                    camRef.current["beforesmily"],
                                    0,
                                    0,
                                    canvas.width,
                                    canvas.height
                                  );
                                  const imageSrc =
                                    canvas.toDataURL("image/webp");
                                  setBeforeSmilyPic(imageSrc);
                                  convertToFile(imageSrc, "beforesmily");
                                  stopVideoStream("beforesmily");
                                  let temp2 = webCamStatus;
                                  temp2[0] = false;
                                  setWebCamStatus([...temp2]);
                                  let temp = [...isHovered];
                                  temp[0] = false;
                                  setIsHovered([...temp]);
                                }}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  class="ionicon"
                                  height="20"
                                  width="20"
                                  viewBox="0 0 512 512"
                                >
                                  <circle cx="256" cy="272" r="64" />
                                  <path d="M432 144h-59c-3 0-6.72-1.94-9.62-5l-25.94-40.94a15.52 15.52 0 00-1.37-1.85C327.11 85.76 315 80 302 80h-92c-13 0-25.11 5.76-34.07 16.21a15.52 15.52 0 00-1.37 1.85l-25.94 41c-2.22 2.42-5.34 5-8.62 5v-8a16 16 0 00-16-16h-24a16 16 0 00-16 16v8h-4a48.05 48.05 0 00-48 48V384a48.05 48.05 0 0048 48h352a48.05 48.05 0 0048-48V192a48.05 48.05 0 00-48-48zM256 368a96 96 0 1196-96 96.11 96.11 0 01-96 96z" />
                                </svg>
                              </IconButton>
                            </Tooltip>

                            <Tooltip title="Switch Camera">
                              <IconButton
                                onClick={() => {
                                  SwitchCamera("beforesmily", 0);
                                }}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  class="ionicon"
                                  height="20"
                                  width="20"
                                  viewBox="0 0 512 512"
                                >
                                  <path d="M432 144h-59c-3 0-6.72-1.94-9.62-5l-25.94-40.94a15.52 15.52 0 00-1.37-1.85C327.11 85.76 315 80 302 80h-92c-13 0-25.11 5.76-34.07 16.21a15.52 15.52 0 00-1.37 1.85l-25.94 41c-2.22 2.42-5.34 5-8.62 5v-8a16 16 0 00-16-16h-24a16 16 0 00-16 16v8h-4a48.05 48.05 0 00-48 48V384a48.05 48.05 0 0048 48h352a48.05 48.05 0 0048-48V192a48.05 48.05 0 00-48-48zM316.84 346.3a96.06 96.06 0 01-155.66-59.18 16 16 0 01-16.49-26.43l20-20a16 16 0 0122.62 0l20 20A16 16 0 01196 288a17.31 17.31 0 01-2-.14 64.07 64.07 0 00102.66 33.63 16 16 0 1120.21 24.81zm50.47-63l-20 20a16 16 0 01-22.62 0l-20-20a16 16 0 0113.09-27.2A64 64 0 00215 222.64 16 16 0 11194.61 198a96 96 0 01156 59 16 16 0 0116.72 26.35z" />
                                </svg>
                              </IconButton>
                            </Tooltip>

                            <Tooltip title="Close Camera">
                              <IconButton
                                onClick={() => {
                                  stopVideoStream("beforesmily");
                                  let temp2 = webCamStatus;
                                  temp2[0] = false;
                                  setWebCamStatus([...temp2]);
                                }}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  class="ionicon"
                                  height="20"
                                  width="20"
                                  viewBox="0 0 512 512"
                                >
                                  <path d="M289.94 256l95-95A24 24 0 00351 127l-95 95-95-95a24 24 0 00-34 34l95 95-95 95a24 24 0 1034 34l95-95 95 95a24 24 0 0034-34z" />
                                </svg>
                              </IconButton>
                            </Tooltip>
                          </div>
                        )}
                        {!webCamStatus[0] && (
                          <div
                            className="text-center"
                            style={{ width: "170px" }}
                          >
                            Smile
                          </div>
                        )}
                      </div>

                      <div
                        style={{
                          display: screenWidth <= 500 ? "flex" : "",
                          flexDirection: screenWidth <= 500 ? "column" : "",
                          alignItems: screenWidth <= 500 ? "center" : "",
                        }}
                        className="col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4 mt-2 position-relative "
                      >
                        <div
                          id="beforefronttooth"
                          onMouseEnter={() =>
                            !webCamStatus[1] && handleMouseEnter(1)
                          }
                          onMouseLeave={() =>
                            !webCamStatus[1] && handleMouseLeave(1)
                          }
                          onDrop={handleDrop}
                          className={
                            "border justify-content-center align-items-center text-center"
                          }
                          onDragOver={(e) => e.preventDefault()}
                          style={{
                            width: "170px",
                            height: "120px",
                            cursor: "pointer",
                            caretColor: "transparent",
                            background:
                              !beforeFrontToothPic &&
                              `url(${FrontToothSVG}) no-repeat center`,
                          }}
                        >
                          {isHovered[1] && (
                            <div
                              className="position-absolute d-flex flex-column align-items-center justify-content-center"
                              style={{
                                width: "160px",
                                height: "110px",
                                top: "1px",
                                backgroundColor: "rgba(256,256,256,0.8)",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-evenly",
                                  width: "-webkit-fill-available",
                                }}
                              >
                                <CiCamera
                                  size={30}
                                  onClick={() => {
                                    let temp = webCamStatus;
                                    temp[1] = true;
                                    setWebCamStatus([...temp]);
                                    let temp2 = [...isHovered];
                                    temp2[1] = false;
                                    setIsHovered([...temp2]);
                                    initializeCamera("beforefronttooth", 1);
                                  }}
                                />
                                <div
                                  style={{
                                    border: "1px solid rgba(0,0,0,0.1)",
                                    position: "absolute",
                                    height: "108%",
                                    top: "0px",
                                  }}
                                ></div>
                                <IoCloudUploadOutline
                                  size={30}
                                  onClick={() => {
                                    let temp = [...isHovered];
                                    temp[1] = false;
                                    setIsHovered([...temp]);
                                    let temp2 = [...webCamStatus];
                                    temp2[1] = false;
                                    setWebCamStatus([...temp2]);

                                    inputRefBeforeFrontToothPic?.current?.click();
                                  }}
                                />
                              </div>
                            </div>
                          )}
                          {imageUploadLoading[1] && beforeFrontToothPic && (
                            <div
                              className="position-absolute"
                              style={{
                                width: "170px",
                                height: "120px",
                                backgroundColor: "rgba(256,256,256,0.4)",
                                zIndex: 99,
                                top: 0,
                              }}
                            >
                              <div
                                className="position-absolute z-1"
                                style={{ top: 25, left: 65, height: 50 }}
                              >
                                <Loader />
                              </div>
                            </div>
                          )}
                          {
                            <input
                              id="beforefronttooth"
                              type="file"
                              accept="image/png, image/jpeg"
                              onChange={(event) => handleImageUpload(event)}
                              ref={inputRefBeforeFrontToothPic}
                              style={{ display: "none" }}
                            />
                          }
                          {!webCamStatus[1] ? (
                            <img
                              src={beforeFrontToothPic || ""}
                              id="beforefronttooth"
                              style={{
                                width: "auto",
                                height: "auto",
                                maxHeight: "110px",
                                maxWidth: "160px",
                              }}
                              // alt="front tooth webcam"
                            />
                          ) : (
                            <div>
                              <video
                                ref={(el) =>
                                  (camRef.current["beforefronttooth"] = el)
                                }
                                autoPlay
                                playsInline
                              />
                              <canvas
                                ref={(el) =>
                                  (canvasRef.current["beforefronttooth"] = el)
                                }
                                style={{ display: "none" }}
                              />
                            </div>
                          )}
                        </div>

                        {webCamStatus[1] && (
                          <div
                            className="d-flex justify-content-between"
                            style={{ width: "170px" }}
                          >
                            <Tooltip title="Capture">
                              <IconButton
                                onClick={() => {
                                  const canvas =
                                    canvasRef.current["beforefronttooth"];
                                  canvas.width = 170;
                                  canvas.height = 115;

                                  const context = canvas.getContext("2d");

                                  context.drawImage(
                                    camRef.current["beforefronttooth"],
                                    0,
                                    0,
                                    canvas.width,
                                    canvas.height
                                  );
                                  const imageSrc =
                                    canvas.toDataURL("image/webp");
                                  setBeforeFrontToothPic(imageSrc);
                                  convertToFile(imageSrc, "beforefronttooth");
                                  stopVideoStream("beforefronttooth");
                                  let temp2 = webCamStatus;
                                  temp2[1] = false;
                                  setWebCamStatus([...temp2]);
                                  let temp = [...isHovered];
                                  temp[1] = false;
                                  setIsHovered([...temp]);
                                }}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  class="ionicon"
                                  height="20"
                                  width="20"
                                  viewBox="0 0 512 512"
                                >
                                  <circle cx="256" cy="272" r="64" />
                                  <path d="M432 144h-59c-3 0-6.72-1.94-9.62-5l-25.94-40.94a15.52 15.52 0 00-1.37-1.85C327.11 85.76 315 80 302 80h-92c-13 0-25.11 5.76-34.07 16.21a15.52 15.52 0 00-1.37 1.85l-25.94 41c-2.22 2.42-5.34 5-8.62 5v-8a16 16 0 00-16-16h-24a16 16 0 00-16 16v8h-4a48.05 48.05 0 00-48 48V384a48.05 48.05 0 0048 48h352a48.05 48.05 0 0048-48V192a48.05 48.05 0 00-48-48zM256 368a96 96 0 1196-96 96.11 96.11 0 01-96 96z" />
                                </svg>
                              </IconButton>
                            </Tooltip>

                            <Tooltip title="Switch Camera">
                              <IconButton
                                onClick={() => {
                                  SwitchCamera("beforefronttooth", 1);
                                }}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  class="ionicon"
                                  height="20"
                                  width="20"
                                  viewBox="0 0 512 512"
                                >
                                  <path d="M432 144h-59c-3 0-6.72-1.94-9.62-5l-25.94-40.94a15.52 15.52 0 00-1.37-1.85C327.11 85.76 315 80 302 80h-92c-13 0-25.11 5.76-34.07 16.21a15.52 15.52 0 00-1.37 1.85l-25.94 41c-2.22 2.42-5.34 5-8.62 5v-8a16 16 0 00-16-16h-24a16 16 0 00-16 16v8h-4a48.05 48.05 0 00-48 48V384a48.05 48.05 0 0048 48h352a48.05 48.05 0 0048-48V192a48.05 48.05 0 00-48-48zM316.84 346.3a96.06 96.06 0 01-155.66-59.18 16 16 0 01-16.49-26.43l20-20a16 16 0 0122.62 0l20 20A16 16 0 01196 288a17.31 17.31 0 01-2-.14 64.07 64.07 0 00102.66 33.63 16 16 0 1120.21 24.81zm50.47-63l-20 20a16 16 0 01-22.62 0l-20-20a16 16 0 0113.09-27.2A64 64 0 00215 222.64 16 16 0 11194.61 198a96 96 0 01156 59 16 16 0 0116.72 26.35z" />
                                </svg>
                              </IconButton>
                            </Tooltip>

                            <Tooltip title="Close Camera">
                              <IconButton
                                onClick={() => {
                                  stopVideoStream("beforefronttooth");
                                  let temp2 = webCamStatus;
                                  temp2[1] = false;
                                  setWebCamStatus([...temp2]);
                                }}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  class="ionicon"
                                  height="20"
                                  width="20"
                                  viewBox="0 0 512 512"
                                >
                                  <path d="M289.94 256l95-95A24 24 0 00351 127l-95 95-95-95a24 24 0 00-34 34l95 95-95 95a24 24 0 1034 34l95-95 95 95a24 24 0 0034-34z" />
                                </svg>
                              </IconButton>
                            </Tooltip>
                          </div>
                        )}
                        {!webCamStatus[1] && (
                          <div
                            className="text-center"
                            style={{ width: "170px" }}
                          >
                            Front Tooth
                          </div>
                        )}
                      </div>

                      <div
                        style={{
                          display: screenWidth <= 500 ? "flex" : "",
                          flexDirection: screenWidth <= 500 ? "column" : "",
                          alignItems: screenWidth <= 500 ? "center" : "",
                        }}
                        className="col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4 mt-2 position-relative "
                      >
                        <div
                          id="beforebuccalleft"
                          onMouseEnter={() =>
                            !webCamStatus[2] && handleMouseEnter(2)
                          }
                          onMouseLeave={() =>
                            !webCamStatus[2] && handleMouseLeave(2)
                          }
                          onDrop={handleDrop}
                          className={
                            "border border justify-content-center align-items-center text-center"
                          }
                          onDragOver={(e) => e.preventDefault()}
                          style={{
                            width: "170px",
                            height: "120px",
                            cursor: "pointer",
                            caretColor: "transparent",
                            background:
                              !beforeBuccalLeftPic &&
                              `url(${BuccalLeftSVG}) no-repeat center`,
                          }}
                        >
                          {isHovered[2] && (
                            <div
                              className="position-absolute d-flex flex-column align-items-center justify-content-center"
                              style={{
                                width: "160px",
                                height: "110px",
                                top: "1px",
                                backgroundColor: "rgba(256,256,256,0.8)",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-evenly",
                                  width: "-webkit-fill-available",
                                }}
                              >
                                <CiCamera
                                  size={30}
                                  onClick={() => {
                                    let temp = webCamStatus;
                                    temp[2] = true;
                                    setWebCamStatus([...temp]);
                                    let temp2 = [...isHovered];
                                    temp2[2] = false;
                                    setIsHovered([...temp2]);
                                    initializeCamera("beforeBuccalLeftPic", 2);
                                  }}
                                />
                                <div
                                  style={{
                                    border: "1px solid rgba(0,0,0,0.1)",
                                    position: "absolute",
                                    height: "108%",
                                    top: "0px",
                                  }}
                                ></div>
                                <IoCloudUploadOutline
                                  size={30}
                                  onClick={() => {
                                    let temp = [...isHovered];
                                    temp[2] = false;
                                    setIsHovered([...temp]);
                                    let temp2 = [...webCamStatus];
                                    temp2[2] = false;
                                    setWebCamStatus([...temp2]);

                                    inputRefBeforeBuccalLeftPic?.current?.click();
                                  }}
                                />
                              </div>
                            </div>
                          )}
                          {imageUploadLoading[2] && beforeBuccalLeftPic && (
                            <div
                              className="position-absolute"
                              style={{
                                width: "170px",
                                height: "120px",
                                backgroundColor: "rgba(256,256,256,0.4)",

                                zIndex: 99,
                                top: 0,
                              }}
                            >
                              <div
                                className="position-absolute z-1"
                                style={{ top: 25, left: 65, height: 50 }}
                              >
                                <Loader />
                              </div>
                            </div>
                          )}
                          {
                            <input
                              id="beforebuccalleft"
                              type="file"
                              accept="image/png, image/jpeg"
                              onChange={(event) => handleImageUpload(event)}
                              ref={inputRefBeforeBuccalLeftPic}
                              style={{ display: "none" }}
                            />
                          }
                          {!webCamStatus[2] ? (
                            <img
                              src={beforeBuccalLeftPic || ""}
                              id="beforebuccalleft"
                              style={{
                                width: "auto",
                                height: "auto",
                                maxHeight: "110px",
                                maxWidth: "160px",
                              }}
                              // alt="buccal left webcam"
                            />
                          ) : (
                            <div>
                              <video
                                ref={(el) =>
                                  (camRef.current["beforebuccalleft"] = el)
                                }
                                autoPlay
                                playsInline
                              />
                              <canvas
                                ref={(el) =>
                                  (canvasRef.current["beforebuccalleft"] = el)
                                }
                                style={{ display: "none" }}
                              />
                            </div>
                          )}
                        </div>

                        {webCamStatus[2] === true && (
                          <div
                            className="d-flex justify-content-between"
                            style={{ width: "170px" }}
                          >
                            <Tooltip title="Capture">
                              <IconButton
                                onClick={() => {
                                  const canvas =
                                    canvasRef.current["beforebuccalleft"];
                                  canvas.width = 170;
                                  canvas.height = 115;

                                  const context = canvas.getContext("2d");

                                  context.drawImage(
                                    camRef.current["beforebuccalleft"],
                                    0,
                                    0,
                                    canvas.width,
                                    canvas.height
                                  );
                                  const imageSrc =
                                    canvas.toDataURL("image/webp");
                                  setBeforeBuccalLeftPic(imageSrc);
                                  convertToFile(imageSrc, "beforebuccalleft");
                                  stopVideoStream("beforebuccalleft");
                                  let temp2 = webCamStatus;
                                  temp2[2] = false;
                                  setWebCamStatus([...temp2]);
                                  let temp = [...isHovered];
                                  temp[2] = false;
                                  setIsHovered([...temp]);
                                }}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  class="ionicon"
                                  height="20"
                                  width="20"
                                  viewBox="0 0 512 512"
                                >
                                  <circle cx="256" cy="272" r="64" />
                                  <path d="M432 144h-59c-3 0-6.72-1.94-9.62-5l-25.94-40.94a15.52 15.52 0 00-1.37-1.85C327.11 85.76 315 80 302 80h-92c-13 0-25.11 5.76-34.07 16.21a15.52 15.52 0 00-1.37 1.85l-25.94 41c-2.22 2.42-5.34 5-8.62 5v-8a16 16 0 00-16-16h-24a16 16 0 00-16 16v8h-4a48.05 48.05 0 00-48 48V384a48.05 48.05 0 0048 48h352a48.05 48.05 0 0048-48V192a48.05 48.05 0 00-48-48zM256 368a96 96 0 1196-96 96.11 96.11 0 01-96 96z" />
                                </svg>
                              </IconButton>
                            </Tooltip>

                            <Tooltip title="Switch Camera">
                              <IconButton
                                onClick={() => {
                                  SwitchCamera("beforebuccalleft", 2);
                                }}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  class="ionicon"
                                  height="20"
                                  width="20"
                                  viewBox="0 0 512 512"
                                >
                                  <path d="M432 144h-59c-3 0-6.72-1.94-9.62-5l-25.94-40.94a15.52 15.52 0 00-1.37-1.85C327.11 85.76 315 80 302 80h-92c-13 0-25.11 5.76-34.07 16.21a15.52 15.52 0 00-1.37 1.85l-25.94 41c-2.22 2.42-5.34 5-8.62 5v-8a16 16 0 00-16-16h-24a16 16 0 00-16 16v8h-4a48.05 48.05 0 00-48 48V384a48.05 48.05 0 0048 48h352a48.05 48.05 0 0048-48V192a48.05 48.05 0 00-48-48zM316.84 346.3a96.06 96.06 0 01-155.66-59.18 16 16 0 01-16.49-26.43l20-20a16 16 0 0122.62 0l20 20A16 16 0 01196 288a17.31 17.31 0 01-2-.14 64.07 64.07 0 00102.66 33.63 16 16 0 1120.21 24.81zm50.47-63l-20 20a16 16 0 01-22.62 0l-20-20a16 16 0 0113.09-27.2A64 64 0 00215 222.64 16 16 0 11194.61 198a96 96 0 01156 59 16 16 0 0116.72 26.35z" />
                                </svg>
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Close Camera">
                              <IconButton
                                onClick={() => {
                                  stopVideoStream("beforebuccalleft");
                                  let temp2 = webCamStatus;
                                  temp2[2] = false;
                                  setWebCamStatus([...temp2]);
                                }}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  class="ionicon"
                                  height="20"
                                  width="20"
                                  viewBox="0 0 512 512"
                                >
                                  <path d="M289.94 256l95-95A24 24 0 00351 127l-95 95-95-95a24 24 0 00-34 34l95 95-95 95a24 24 0 1034 34l95-95 95 95a24 24 0 0034-34z" />
                                </svg>
                              </IconButton>
                            </Tooltip>
                          </div>
                        )}
                        {!webCamStatus[2] && (
                          <div
                            className="text-center"
                            style={{ width: "170px" }}
                          >
                            Buccal Left
                          </div>
                        )}
                      </div>

                      <div
                        style={{
                          display: screenWidth <= 500 ? "flex" : "",
                          flexDirection: screenWidth <= 500 ? "column" : "",
                          alignItems: screenWidth <= 500 ? "center" : "",
                        }}
                        className="col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4 mt-2 position-relative "
                      >
                        <div
                          id="beforebuccalright"
                          onMouseEnter={() =>
                            !webCamStatus[3] && handleMouseEnter(3)
                          }
                          onMouseLeave={() =>
                            !webCamStatus[3] && handleMouseLeave(3)
                          }
                          onDrop={handleDrop}
                          className={
                            "border justify-content-center align-items-center text-center"
                          }
                          onDragOver={(e) => e.preventDefault()}
                          style={{
                            width: "170px",
                            height: "120px",
                            cursor: "pointer",
                            caretColor: "transparent",
                            background:
                              !beforeBuccalRightPic &&
                              `url(${BuccalRightSVG}) no-repeat center`,
                          }}
                        >
                          {isHovered[3] && (
                            <div
                              className="position-absolute d-flex flex-column align-items-center justify-content-center"
                              style={{
                                width: "160px",
                                height: "110px",
                                top: "1px",
                                backgroundColor: "rgba(256,256,256,0.8)",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-evenly",
                                  width: "-webkit-fill-available",
                                }}
                              >
                                <CiCamera
                                  size={30}
                                  onClick={() => {
                                    let temp = [...webCamStatus];
                                    temp[3] = true;
                                    setWebCamStatus([...temp]);
                                    let temp2 = [...isHovered];
                                    temp2[3] = false;
                                    setIsHovered([...temp2]);
                                    initializeCamera("beforebuccalright", 3);
                                  }}
                                />
                                <div
                                  style={{
                                    border: "1px solid rgba(0,0,0,0.1)",
                                    position: "absolute",
                                    height: "108%",
                                    top: "0px",
                                  }}
                                ></div>
                                <IoCloudUploadOutline
                                  size={30}
                                  onClick={() => {
                                    let temp = [...isHovered];
                                    temp[3] = false;
                                    setIsHovered([...temp]);
                                    let temp2 = [...webCamStatus];
                                    temp2[3] = false;
                                    setWebCamStatus([...temp2]);

                                    inputRefBeforeBuccalRightPic?.current?.click();
                                  }}
                                />
                              </div>
                            </div>
                          )}
                          {imageUploadLoading[3] && beforeBuccalRightPic && (
                            <div
                              className="position-absolute"
                              style={{
                                width: "170px",
                                height: "120px",
                                backgroundColor: "rgba(256,256,256,0.4)",

                                zIndex: 99,
                                top: 0,
                              }}
                            >
                              <div
                                className="position-absolute z-1"
                                style={{ top: 25, left: 65, height: 50 }}
                              >
                                <Loader />
                              </div>
                            </div>
                          )}
                          {
                            <input
                              id="beforebuccalright"
                              type="file"
                              accept="image/png, image/jpeg"
                              onChange={(event) => handleImageUpload(event)}
                              ref={inputRefBeforeBuccalRightPic}
                              style={{ display: "none" }}
                            />
                          }
                          {!webCamStatus[3] ? (
                            <img
                              src={beforeBuccalRightPic || ""}
                              id="beforebuccalright"
                              style={{
                                width: "auto",
                                height: "auto",
                                maxHeight: "110px",
                                maxWidth: "160px",
                              }}
                              // alt="buccal right webcam"
                            />
                          ) : (
                            <div>
                              <video
                                ref={(el) =>
                                  (camRef.current["beforebuccalright"] = el)
                                }
                                autoPlay
                                playsInline
                              />
                              <canvas
                                ref={(el) =>
                                  (canvasRef.current["beforebuccalright"] = el)
                                }
                                style={{ display: "none" }}
                              />
                            </div>
                          )}
                        </div>

                        {webCamStatus[3] && (
                          <div
                            className="d-flex justify-content-between"
                            style={{ width: "170px" }}
                          >
                            <Tooltip title="Capture">
                              <IconButton
                                onClick={() => {
                                  const canvas =
                                    canvasRef.current["beforebuccalright"];
                                  canvas.width = 170;
                                  canvas.height = 115;

                                  const context = canvas.getContext("2d");

                                  context.drawImage(
                                    camRef.current["beforebuccalright"],
                                    0,
                                    0,
                                    canvas.width,
                                    canvas.height
                                  );
                                  const imageSrc =
                                    canvas.toDataURL("image/webp");

                                  setBeforeBuccalRightPic(imageSrc);
                                  convertToFile(imageSrc, "beforebuccalright");
                                  stopVideoStream("beforebuccalright");
                                  let temp2 = webCamStatus;
                                  temp2[3] = false;
                                  setWebCamStatus([...temp2]);
                                  let temp = [...isHovered];
                                  temp[3] = false;
                                  setIsHovered([...temp]);
                                }}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  class="ionicon"
                                  height="20"
                                  width="20"
                                  viewBox="0 0 512 512"
                                >
                                  <circle cx="256" cy="272" r="64" />
                                  <path d="M432 144h-59c-3 0-6.72-1.94-9.62-5l-25.94-40.94a15.52 15.52 0 00-1.37-1.85C327.11 85.76 315 80 302 80h-92c-13 0-25.11 5.76-34.07 16.21a15.52 15.52 0 00-1.37 1.85l-25.94 41c-2.22 2.42-5.34 5-8.62 5v-8a16 16 0 00-16-16h-24a16 16 0 00-16 16v8h-4a48.05 48.05 0 00-48 48V384a48.05 48.05 0 0048 48h352a48.05 48.05 0 0048-48V192a48.05 48.05 0 00-48-48zM256 368a96 96 0 1196-96 96.11 96.11 0 01-96 96z" />
                                </svg>
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Switch Camera">
                              <IconButton
                                onClick={() => {
                                  SwitchCamera("beforebuccalright", 3);
                                }}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  class="ionicon"
                                  height="20"
                                  width="20"
                                  viewBox="0 0 512 512"
                                >
                                  <path d="M432 144h-59c-3 0-6.72-1.94-9.62-5l-25.94-40.94a15.52 15.52 0 00-1.37-1.85C327.11 85.76 315 80 302 80h-92c-13 0-25.11 5.76-34.07 16.21a15.52 15.52 0 00-1.37 1.85l-25.94 41c-2.22 2.42-5.34 5-8.62 5v-8a16 16 0 00-16-16h-24a16 16 0 00-16 16v8h-4a48.05 48.05 0 00-48 48V384a48.05 48.05 0 0048 48h352a48.05 48.05 0 0048-48V192a48.05 48.05 0 00-48-48zM316.84 346.3a96.06 96.06 0 01-155.66-59.18 16 16 0 01-16.49-26.43l20-20a16 16 0 0122.62 0l20 20A16 16 0 01196 288a17.31 17.31 0 01-2-.14 64.07 64.07 0 00102.66 33.63 16 16 0 1120.21 24.81zm50.47-63l-20 20a16 16 0 01-22.62 0l-20-20a16 16 0 0113.09-27.2A64 64 0 00215 222.64 16 16 0 11194.61 198a96 96 0 01156 59 16 16 0 0116.72 26.35z" />
                                </svg>
                              </IconButton>
                            </Tooltip>

                            <Tooltip title="Close Camera">
                              <IconButton
                                onClick={() => {
                                  stopVideoStream("beforebuccalright");
                                  let temp2 = webCamStatus;
                                  temp2[3] = false;
                                  setWebCamStatus([...temp2]);
                                }}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  class="ionicon"
                                  height="20"
                                  width="20"
                                  viewBox="0 0 512 512"
                                >
                                  <path d="M289.94 256l95-95A24 24 0 00351 127l-95 95-95-95a24 24 0 00-34 34l95 95-95 95a24 24 0 1034 34l95-95 95 95a24 24 0 0034-34z" />
                                </svg>
                              </IconButton>
                            </Tooltip>
                          </div>
                        )}
                        {!webCamStatus[3] && (
                          <div
                            className="text-center"
                            style={{ width: "170px" }}
                          >
                            Buccal Right
                          </div>
                        )}
                      </div>

                      <div
                        style={{
                          display: screenWidth <= 500 ? "flex" : "",
                          flexDirection: screenWidth <= 500 ? "column" : "",
                          alignItems: screenWidth <= 500 ? "center" : "",
                        }}
                        className="col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4 mt-2 position-relative "
                      >
                        <div
                          id="beforeocclusalupper"
                          onMouseEnter={() =>
                            !webCamStatus[4] && handleMouseEnter(4)
                          }
                          onMouseLeave={() =>
                            !webCamStatus[4] && handleMouseLeave(4)
                          }
                          onDrop={handleDrop}
                          className={
                            "border justify-content-center align-items-center text-center"
                          }
                          onDragOver={(e) => e.preventDefault()}
                          style={{
                            width: "170px",
                            height: "120px",
                            cursor: "pointer",
                            caretColor: "transparent",
                            background:
                              !beforeOcclusalUpperPic &&
                              `url(${OcclusalUpperSVG}) no-repeat center`,
                          }}
                        >
                          {isHovered[4] && (
                            <div
                              className="position-absolute d-flex flex-column align-items-center justify-content-center"
                              style={{
                                width: "160px",
                                height: "110px",
                                top: "1px",
                                backgroundColor: "rgba(256,256,256,0.8)",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-evenly",
                                  width: "-webkit-fill-available",
                                }}
                              >
                                <CiCamera
                                  size={30}
                                  onClick={() => {
                                    let temp = webCamStatus;
                                    temp[4] = true;
                                    setWebCamStatus([...temp]);
                                    let temp2 = [...isHovered];
                                    temp2[4] = false;
                                    setIsHovered([...temp2]);
                                    initializeCamera("beforeocclusalupper", 4);
                                  }}
                                />
                                <div
                                  style={{
                                    border: "1px solid rgba(0,0,0,0.1)",
                                    position: "absolute",
                                    height: "108%",
                                    top: "0px",
                                  }}
                                ></div>
                                <IoCloudUploadOutline
                                  size={30}
                                  onClick={() => {
                                    let temp = [...isHovered];
                                    temp[4] = false;
                                    setIsHovered([...temp]);
                                    let temp2 = [...webCamStatus];
                                    temp2[4] = false;
                                    setWebCamStatus([...temp2]);

                                    inputRefBeforeOcclusalUpperPic?.current?.click();
                                  }}
                                />
                              </div>
                            </div>
                          )}
                          {imageUploadLoading[4] && beforeOcclusalUpperPic && (
                            <div
                              className="position-absolute"
                              style={{
                                width: "170px",
                                height: "120px",
                                backgroundColor: "rgba(256,256,256,0.4)",

                                zIndex: 99,
                                top: 0,
                              }}
                            >
                              <div
                                className="position-absolute z-1"
                                style={{ top: 25, left: 65, height: 50 }}
                              >
                                <Loader />
                              </div>
                            </div>
                          )}
                          {
                            <input
                              id="beforeocclusalupper"
                              type="file"
                              accept="image/png, image/jpeg"
                              onChange={(event) => handleImageUpload(event)}
                              ref={inputRefBeforeBuccalRightPic}
                              style={{ display: "none" }}
                            />
                          }
                          {!webCamStatus[4] ? (
                            <img
                              src={beforeOcclusalUpperPic || ""}
                              id="beforeocclusalupper"
                              style={{
                                width: "auto",
                                height: "auto",
                                maxHeight: "110px",
                                maxWidth: "160px",
                              }}
                              // alt="occlusal upper webcam"
                            />
                          ) : (
                            <div>
                              <video
                                ref={(el) =>
                                  (camRef.current["beforeocclusalupper"] = el)
                                }
                                autoPlay
                                playsInline
                              />
                              <canvas
                                ref={(el) =>
                                  (canvasRef.current["beforeocclusalupper"] =
                                    el)
                                }
                                style={{ display: "none" }}
                              />
                            </div>
                          )}
                        </div>

                        {webCamStatus[4] && (
                          <div
                            className="d-flex justify-content-between"
                            style={{ width: "170px" }}
                          >
                            <Tooltip title="Capture">
                              <IconButton
                                onClick={() => {
                                  const canvas =
                                    canvasRef.current["beforeocclusalupper"];
                                  canvas.width = 170;
                                  canvas.height = 115;

                                  const context = canvas.getContext("2d");

                                  context.drawImage(
                                    camRef.current["beforeocclusalupper"],
                                    0,
                                    0,
                                    canvas.width,
                                    canvas.height
                                  );
                                  const imageSrc =
                                    canvas.toDataURL("image/webp");
                                  setBeforeOcclusalUpperPic(imageSrc);
                                  convertToFile(
                                    imageSrc,
                                    "beforeocclusalupper"
                                  );

                                  stopVideoStream("beforeocclusalupper");
                                  let temp2 = webCamStatus;
                                  temp2[4] = false;
                                  setWebCamStatus([...temp2]);
                                  let temp = [...isHovered];
                                  temp[4] = false;
                                  setIsHovered([...temp]);
                                }}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  class="ionicon"
                                  height="20"
                                  width="20"
                                  viewBox="0 0 512 512"
                                >
                                  <circle cx="256" cy="272" r="64" />
                                  <path d="M432 144h-59c-3 0-6.72-1.94-9.62-5l-25.94-40.94a15.52 15.52 0 00-1.37-1.85C327.11 85.76 315 80 302 80h-92c-13 0-25.11 5.76-34.07 16.21a15.52 15.52 0 00-1.37 1.85l-25.94 41c-2.22 2.42-5.34 5-8.62 5v-8a16 16 0 00-16-16h-24a16 16 0 00-16 16v8h-4a48.05 48.05 0 00-48 48V384a48.05 48.05 0 0048 48h352a48.05 48.05 0 0048-48V192a48.05 48.05 0 00-48-48zM256 368a96 96 0 1196-96 96.11 96.11 0 01-96 96z" />
                                </svg>
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Switch Camera">
                              <IconButton
                                onClick={() => {
                                  SwitchCamera("beforeocclusalupper", 4);
                                }}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  class="ionicon"
                                  height="20"
                                  width="20"
                                  viewBox="0 0 512 512"
                                >
                                  <path d="M432 144h-59c-3 0-6.72-1.94-9.62-5l-25.94-40.94a15.52 15.52 0 00-1.37-1.85C327.11 85.76 315 80 302 80h-92c-13 0-25.11 5.76-34.07 16.21a15.52 15.52 0 00-1.37 1.85l-25.94 41c-2.22 2.42-5.34 5-8.62 5v-8a16 16 0 00-16-16h-24a16 16 0 00-16 16v8h-4a48.05 48.05 0 00-48 48V384a48.05 48.05 0 0048 48h352a48.05 48.05 0 0048-48V192a48.05 48.05 0 00-48-48zM316.84 346.3a96.06 96.06 0 01-155.66-59.18 16 16 0 01-16.49-26.43l20-20a16 16 0 0122.62 0l20 20A16 16 0 01196 288a17.31 17.31 0 01-2-.14 64.07 64.07 0 00102.66 33.63 16 16 0 1120.21 24.81zm50.47-63l-20 20a16 16 0 01-22.62 0l-20-20a16 16 0 0113.09-27.2A64 64 0 00215 222.64 16 16 0 11194.61 198a96 96 0 01156 59 16 16 0 0116.72 26.35z" />
                                </svg>
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Close Camera">
                              <IconButton
                                onClick={() => {
                                  stopVideoStream("beforeocclusalupper");
                                  let temp2 = webCamStatus;
                                  temp2[4] = false;
                                  setWebCamStatus([...temp2]);
                                }}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  class="ionicon"
                                  height="20"
                                  width="20"
                                  viewBox="0 0 512 512"
                                >
                                  <path d="M289.94 256l95-95A24 24 0 00351 127l-95 95-95-95a24 24 0 00-34 34l95 95-95 95a24 24 0 1034 34l95-95 95 95a24 24 0 0034-34z" />
                                </svg>
                              </IconButton>
                            </Tooltip>
                          </div>
                        )}
                        {!webCamStatus[4] && (
                          <div
                            className="text-center"
                            style={{ width: "170px" }}
                          >
                            Occlusal Upper
                          </div>
                        )}
                      </div>

                      <div
                        style={{
                          display: screenWidth <= 500 ? "flex" : "",
                          flexDirection: screenWidth <= 500 ? "column" : "",
                          alignItems: screenWidth <= 500 ? "center" : "",
                        }}
                        className="col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4 mt-2 position-relative "
                      >
                        <div
                          id="beforeocclusallower"
                          onMouseEnter={() =>
                            !webCamStatus[5] && handleMouseEnter(5)
                          }
                          onMouseLeave={() =>
                            !webCamStatus[5] && handleMouseLeave(5)
                          }
                          onDrop={handleDrop}
                          className={
                            "border justify-content-center align-items-center text-center"
                          }
                          onDragOver={(e) => e.preventDefault()}
                          style={{
                            width: "170px",
                            height: "120px",
                            cursor: "pointer",
                            caretColor: "transparent",
                            background:
                              !beforeOcclusalLowerPic &&
                              `url(${OcclusalLowerSVG}) no-repeat center`,
                          }}
                        >
                          {isHovered[5] && (
                            <div
                              className="position-absolute d-flex flex-column align-items-center justify-content-center"
                              style={{
                                width: "160px",
                                height: "110px",
                                top: "1px",
                                backgroundColor: "rgba(256,256,256,0.8)",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-evenly",
                                  width: "-webkit-fill-available",
                                }}
                              >
                                <CiCamera
                                  size={30}
                                  onClick={() => {
                                    let temp = webCamStatus;
                                    temp[5] = true;
                                    setWebCamStatus([...temp]);
                                    let temp2 = [...isHovered];
                                    temp2[5] = false;
                                    setIsHovered([...temp2]);
                                    initializeCamera("beforeocclusallower", 5);
                                  }}
                                />
                                <div
                                  style={{
                                    border: "1px solid rgba(0,0,0,0.1)",
                                    position: "absolute",
                                    height: "108%",
                                    top: "0px",
                                  }}
                                ></div>
                                <IoCloudUploadOutline
                                  size={30}
                                  onClick={() => {
                                    let temp = [...isHovered];
                                    temp[5] = false;
                                    setIsHovered([...temp]);
                                    let temp2 = [...webCamStatus];
                                    temp2[5] = false;
                                    setWebCamStatus([...temp2]);

                                    inputRefBeforeOcclusalLowerPic?.current?.click();
                                  }}
                                />
                              </div>
                            </div>
                          )}
                          {imageUploadLoading[5] && beforeOcclusalLowerPic && (
                            <div
                              className="position-absolute"
                              style={{
                                width: "170px",
                                height: "120px",
                                backgroundColor: "rgba(256,256,256,0.4)",

                                zIndex: 99,
                                top: 0,
                              }}
                            >
                              <div
                                className="position-absolute z-1"
                                style={{ top: 25, left: 65, height: 50 }}
                              >
                                <Loader />
                              </div>
                            </div>
                          )}
                          {
                            <input
                              id="beforeocclusallower"
                              type="file"
                              accept="image/png, image/jpeg"
                              onChange={(event) => handleImageUpload(event)}
                              ref={inputRefBeforeOcclusalLowerPic}
                              style={{ display: "none" }}
                            />
                          }
                          {!webCamStatus[5] ? (
                            <img
                              src={beforeOcclusalLowerPic || ""}
                              id="beforeocclusallower"
                              style={{
                                width: "auto",
                                height: "auto",
                                maxHeight: "110px",
                                maxWidth: "160px",
                              }}
                              // alt="occlual lower webcam"
                            />
                          ) : (
                            <div>
                              <video
                                ref={(el) =>
                                  (camRef.current["beforeocclusallower"] = el)
                                }
                                autoPlay
                                playsInline
                              />
                              <canvas
                                ref={(el) =>
                                  (canvasRef.current["beforeocclusallower"] =
                                    el)
                                }
                                style={{ display: "none" }}
                              />
                            </div>
                          )}
                        </div>

                        {webCamStatus[5] && (
                          <div
                            className="d-flex justify-content-between"
                            style={{ width: "170px" }}
                          >
                            <Tooltip title="Capture">
                              <IconButton
                                onClick={() => {
                                  const canvas =
                                    canvasRef.current["beforeocclusallower"];
                                  canvas.width = 170;
                                  canvas.height = 115;

                                  const context = canvas.getContext("2d");

                                  context.drawImage(
                                    camRef.current["beforeocclusallower"],
                                    0,
                                    0,
                                    canvas.width,
                                    canvas.height
                                  );
                                  const imageSrc =
                                    canvas.toDataURL("image/webp");
                                  setBeforeOcclusalLowerPic(imageSrc);
                                  convertToFile(
                                    imageSrc,
                                    "beforeocclusallower"
                                  );

                                  stopVideoStream("beforeocclusallower");
                                  let temp2 = webCamStatus;
                                  temp2[5] = false;
                                  setWebCamStatus([...temp2]);
                                  let temp = [...isHovered];
                                  temp[5] = false;
                                  setIsHovered([...temp]);
                                }}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  class="ionicon"
                                  height="20"
                                  width="20"
                                  viewBox="0 0 512 512"
                                >
                                  <circle cx="256" cy="272" r="64" />
                                  <path d="M432 144h-59c-3 0-6.72-1.94-9.62-5l-25.94-40.94a15.52 15.52 0 00-1.37-1.85C327.11 85.76 315 80 302 80h-92c-13 0-25.11 5.76-34.07 16.21a15.52 15.52 0 00-1.37 1.85l-25.94 41c-2.22 2.42-5.34 5-8.62 5v-8a16 16 0 00-16-16h-24a16 16 0 00-16 16v8h-4a48.05 48.05 0 00-48 48V384a48.05 48.05 0 0048 48h352a48.05 48.05 0 0048-48V192a48.05 48.05 0 00-48-48zM256 368a96 96 0 1196-96 96.11 96.11 0 01-96 96z" />
                                </svg>
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Switch Camera">
                              <IconButton
                                onClick={() => {
                                  SwitchCamera("beforeocclusallower", 5);
                                }}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  class="ionicon"
                                  height="20"
                                  width="20"
                                  viewBox="0 0 512 512"
                                >
                                  <path d="M432 144h-59c-3 0-6.72-1.94-9.62-5l-25.94-40.94a15.52 15.52 0 00-1.37-1.85C327.11 85.76 315 80 302 80h-92c-13 0-25.11 5.76-34.07 16.21a15.52 15.52 0 00-1.37 1.85l-25.94 41c-2.22 2.42-5.34 5-8.62 5v-8a16 16 0 00-16-16h-24a16 16 0 00-16 16v8h-4a48.05 48.05 0 00-48 48V384a48.05 48.05 0 0048 48h352a48.05 48.05 0 0048-48V192a48.05 48.05 0 00-48-48zM316.84 346.3a96.06 96.06 0 01-155.66-59.18 16 16 0 01-16.49-26.43l20-20a16 16 0 0122.62 0l20 20A16 16 0 01196 288a17.31 17.31 0 01-2-.14 64.07 64.07 0 00102.66 33.63 16 16 0 1120.21 24.81zm50.47-63l-20 20a16 16 0 01-22.62 0l-20-20a16 16 0 0113.09-27.2A64 64 0 00215 222.64 16 16 0 11194.61 198a96 96 0 01156 59 16 16 0 0116.72 26.35z" />
                                </svg>
                              </IconButton>
                            </Tooltip>

                            <Tooltip title="Close Camera">
                              <IconButton
                                onClick={() => {
                                  stopVideoStream("beforeocclusallower");
                                  let temp2 = webCamStatus;
                                  temp2[5] = false;
                                  setWebCamStatus([...temp2]);
                                }}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  class="ionicon"
                                  height="20"
                                  width="20"
                                  viewBox="0 0 512 512"
                                >
                                  <path d="M289.94 256l95-95A24 24 0 00351 127l-95 95-95-95a24 24 0 00-34 34l95 95-95 95a24 24 0 1034 34l95-95 95 95a24 24 0 0034-34z" />
                                </svg>
                              </IconButton>
                            </Tooltip>
                          </div>
                        )}
                        {!webCamStatus[5] && (
                          <div
                            className="text-center"
                            style={{ width: "170px" }}
                          >
                            Occlusal Lower
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}

                {switchedAligner && (
                  <div
                    className="row w-100 mx-auto flex-column align-items-center justify-content-start"
                    style={{
                      gap: "8px",
                    }}
                  >
                    <div
                      className="text-center"
                      style={{ color: PRIMARY_COLOR }}
                    >
                      <h6>After (With New Aligners)</h6>
                    </div>

                    <div
                      className="row w-100 mx-auto flex-column flex-sm-row align-items-center justify-content-center"
                      style={{
                        rowGap: "15px",
                        maxWidth: "700px",
                      }}
                    >
                      <div
                        style={{
                          display: screenWidth <= 500 ? "flex" : "",
                          flexDirection: screenWidth <= 500 ? "column" : "",
                          alignItems: screenWidth <= 500 ? "center" : "",
                        }}
                        className="col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4 mt-2 position-relative"
                      >
                        <div
                          id="aftersmily"
                          onMouseEnter={() =>
                            !webCamStatus[6] && handleMouseEnter(6)
                          }
                          onMouseLeave={() =>
                            !webCamStatus[6] && handleMouseLeave(6)
                          }
                          onDrop={handleDrop}
                          className={
                            "border justify-content-center align-items-center text-center"
                          }
                          onDragOver={(e) => e.preventDefault()}
                          style={{
                            width: "170px",
                            height: "120px",
                            cursor: "pointer",
                            caretColor: "transparent",
                            background:
                              !afterSmilyPic &&
                              `url(${SmilySVG}) no-repeat center`,
                          }}
                        >
                          {isHovered[6] && (
                            <div
                              className="position-absolute d-flex flex-column align-items-center justify-content-center"
                              style={{
                                width: "160px",
                                height: "110px",
                                top: "1px",
                                backgroundColor: "rgba(256,256,256,0.8)",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-evenly",
                                  width: "-webkit-fill-available",
                                }}
                              >
                                <CiCamera
                                  size={30}
                                  onClick={() => {
                                    let temp = webCamStatus;
                                    temp[6] = true;
                                    setWebCamStatus([...temp]);
                                    let temp2 = [...isHovered];
                                    temp2[6] = false;
                                    setIsHovered([...temp2]);
                                    initializeCamera("afterSmilyPic", 6);
                                  }}
                                />
                                <div
                                  style={{
                                    border: "1px solid rgba(0,0,0,0.1)",
                                    position: "absolute",
                                    height: "108%",
                                    top: "0px",
                                  }}
                                ></div>
                                <IoCloudUploadOutline
                                  size={30}
                                  onClick={() => {
                                    let temp = [...isHovered];
                                    temp[6] = false;
                                    setIsHovered([...temp]);
                                    let temp2 = [...webCamStatus];
                                    temp2[6] = false;
                                    setWebCamStatus([...temp2]);

                                    inputRefAfterSmily?.current?.click();
                                  }}
                                />
                              </div>
                            </div>
                          )}
                          {imageUploadLoading[6] && afterSmilyPic && (
                            <div
                              className="position-absolute"
                              style={{
                                width: "170px",
                                height: "120px",
                                backgroundColor: "rgba(256,256,256,0.4)",

                                zIndex: 99,
                                top: 0,
                              }}
                            >
                              <div
                                className="position-absolute z-1"
                                style={{ top: 25, left: 65, height: 50 }}
                              >
                                <Loader />
                              </div>
                            </div>
                          )}
                          {
                            <input
                              id="afterSmilyPic"
                              type="file"
                              accept="image/png, image/jpeg"
                              onChange={(event) => handleImageUpload(event)}
                              ref={inputRefAfterSmily}
                              style={{ display: "none" }}
                            />
                          }
                          {!webCamStatus[6] ? (
                            <img
                              src={afterSmilyPic || ""}
                              id="aftersmily"
                              style={{
                                width: "auto",
                                height: "auto",
                                maxHeight: "110px",
                                maxWidth: "160px",
                              }}
                              // alt="smily webcam"
                            />
                          ) : (
                            <div>
                              <video
                                ref={(el) =>
                                  (camRef.current["aftersmily"] = el)
                                }
                                autoPlay
                                playsInline
                              />
                              <canvas
                                ref={(el) =>
                                  (canvasRef.current["aftersmily"] = el)
                                }
                                style={{ display: "none" }}
                              />
                            </div>
                          )}
                        </div>

                        {webCamStatus[6] && (
                          <div
                            className="d-flex justify-content-between"
                            style={{ width: "170px" }}
                          >
                            <Tooltip title="Capture">
                              <IconButton
                                onClick={() => {
                                  const canvas =
                                    canvasRef.current["aftersmily"];
                                  canvas.width = 170;
                                  canvas.height = 115;

                                  const context = canvas.getContext("2d");

                                  context.drawImage(
                                    camRef.current["aftersmily"],
                                    0,
                                    0,
                                    canvas.width,
                                    canvas.height
                                  );
                                  const imageSrc =
                                    canvas.toDataURL("image/webp");
                                  setAfterSmilyPic(imageSrc);
                                  convertToFile(imageSrc, "aftersmily");
                                  stopVideoStream("aftersmily");
                                  let temp2 = webCamStatus;
                                  temp2[6] = false;
                                  setWebCamStatus([...temp2]);
                                  let temp = [...isHovered];
                                  temp[6] = false;
                                  setIsHovered([...temp]);
                                }}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  class="ionicon"
                                  height="20"
                                  width="20"
                                  viewBox="0 0 512 512"
                                >
                                  <circle cx="256" cy="272" r="64" />
                                  <path d="M432 144h-59c-3 0-6.72-1.94-9.62-5l-25.94-40.94a15.52 15.52 0 00-1.37-1.85C327.11 85.76 315 80 302 80h-92c-13 0-25.11 5.76-34.07 16.21a15.52 15.52 0 00-1.37 1.85l-25.94 41c-2.22 2.42-5.34 5-8.62 5v-8a16 16 0 00-16-16h-24a16 16 0 00-16 16v8h-4a48.05 48.05 0 00-48 48V384a48.05 48.05 0 0048 48h352a48.05 48.05 0 0048-48V192a48.05 48.05 0 00-48-48zM256 368a96 96 0 1196-96 96.11 96.11 0 01-96 96z" />
                                </svg>
                              </IconButton>
                            </Tooltip>

                            <Tooltip title="Switch Camera">
                              <IconButton
                                onClick={() => {
                                  SwitchCamera("aftersmily", 6);
                                }}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  class="ionicon"
                                  height="20"
                                  width="20"
                                  viewBox="0 0 512 512"
                                >
                                  <path d="M432 144h-59c-3 0-6.72-1.94-9.62-5l-25.94-40.94a15.52 15.52 0 00-1.37-1.85C327.11 85.76 315 80 302 80h-92c-13 0-25.11 5.76-34.07 16.21a15.52 15.52 0 00-1.37 1.85l-25.94 41c-2.22 2.42-5.34 5-8.62 5v-8a16 16 0 00-16-16h-24a16 16 0 00-16 16v8h-4a48.05 48.05 0 00-48 48V384a48.05 48.05 0 0048 48h352a48.05 48.05 0 0048-48V192a48.05 48.05 0 00-48-48zM316.84 346.3a96.06 96.06 0 01-155.66-59.18 16 16 0 01-16.49-26.43l20-20a16 16 0 0122.62 0l20 20A16 16 0 01196 288a17.31 17.31 0 01-2-.14 64.07 64.07 0 00102.66 33.63 16 16 0 1120.21 24.81zm50.47-63l-20 20a16 16 0 01-22.62 0l-20-20a16 16 0 0113.09-27.2A64 64 0 00215 222.64 16 16 0 11194.61 198a96 96 0 01156 59 16 16 0 0116.72 26.35z" />
                                </svg>
                              </IconButton>
                            </Tooltip>

                            <Tooltip title="Close Camera">
                              <IconButton
                                onClick={() => {
                                  stopVideoStream("aftersmily");
                                  let temp2 = webCamStatus;
                                  temp2[6] = false;
                                  setWebCamStatus([...temp2]);
                                }}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  class="ionicon"
                                  height="20"
                                  width="20"
                                  viewBox="0 0 512 512"
                                >
                                  <path d="M289.94 256l95-95A24 24 0 00351 127l-95 95-95-95a24 24 0 00-34 34l95 95-95 95a24 24 0 1034 34l95-95 95 95a24 24 0 0034-34z" />
                                </svg>
                              </IconButton>
                            </Tooltip>
                          </div>
                        )}
                        {!webCamStatus[6] && (
                          <div
                            className="text-center"
                            style={{ width: "170px" }}
                          >
                            Smile
                          </div>
                        )}
                      </div>

                      <div
                        style={{
                          display: screenWidth <= 500 ? "flex" : "",
                          flexDirection: screenWidth <= 500 ? "column" : "",
                          alignItems: screenWidth <= 500 ? "center" : "",
                        }}
                        className="col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4 mt-2 position-relative "
                      >
                        <div
                          id="afterfronttooth"
                          onMouseEnter={() =>
                            !webCamStatus[7] && handleMouseEnter(7)
                          }
                          onMouseLeave={() =>
                            !webCamStatus[7] && handleMouseLeave(7)
                          }
                          onDrop={handleDrop}
                          className={
                            "border justify-content-center align-items-center text-center"
                          }
                          onDragOver={(e) => e.preventDefault()}
                          style={{
                            width: "170px",
                            height: "120px",
                            cursor: "pointer",
                            caretColor: "transparent",
                            background:
                              !afterFrontToothPic &&
                              `url(${FrontToothSVG}) no-repeat center`,
                          }}
                        >
                          {isHovered[7] && (
                            <div
                              className="position-absolute d-flex flex-column align-items-center justify-content-center"
                              style={{
                                width: "160px",
                                height: "110px",
                                top: "1px",
                                backgroundColor: "rgba(256,256,256,0.8)",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-evenly",
                                  width: "-webkit-fill-available",
                                }}
                              >
                                <CiCamera
                                  size={30}
                                  onClick={() => {
                                    let temp = webCamStatus;
                                    temp[7] = true;
                                    setWebCamStatus([...temp]);
                                    let temp2 = [...isHovered];
                                    temp2[7] = false;
                                    setIsHovered([...temp2]);
                                    initializeCamera("afterfronttooth", 7);
                                  }}
                                />
                                <div
                                  style={{
                                    border: "1px solid rgba(0,0,0,0.1)",
                                    position: "absolute",
                                    height: "108%",
                                    top: "0px",
                                  }}
                                ></div>
                                <IoCloudUploadOutline
                                  size={30}
                                  onClick={() => {
                                    let temp = [...isHovered];
                                    temp[7] = false;
                                    setIsHovered([...temp]);
                                    let temp2 = [...webCamStatus];
                                    temp2[7] = false;
                                    setWebCamStatus([...temp2]);

                                    inputRefAfterFrontToothPic?.current?.click();
                                  }}
                                />
                              </div>
                            </div>
                          )}
                          {imageUploadLoading[7] && afterFrontToothPic && (
                            <div
                              className="position-absolute"
                              style={{
                                width: "170px",
                                height: "120px",
                                backgroundColor: "rgba(256,256,256,0.4)",
                                zIndex: 99,
                                top: 0,
                              }}
                            >
                              <div
                                className="position-absolute z-1"
                                style={{ top: 25, left: 65, height: 50 }}
                              >
                                <Loader />
                              </div>
                            </div>
                          )}
                          {
                            <input
                              id="afterfronttooth"
                              type="file"
                              accept="image/png, image/jpeg"
                              onChange={(event) => handleImageUpload(event)}
                              ref={inputRefAfterFrontToothPic}
                              style={{ display: "none" }}
                            />
                          }
                          {!webCamStatus[7] ? (
                            <img
                              src={afterFrontToothPic || ""}
                              id="afterfronttooth"
                              style={{
                                width: "auto",
                                height: "auto",
                                maxHeight: "110px",
                                maxWidth: "160px",
                              }}
                              // alt="front tooth webcam"
                            />
                          ) : (
                            <div>
                              <video
                                ref={(el) =>
                                  (camRef.current["afterfronttooth"] = el)
                                }
                                autoPlay
                                playsInline
                              />
                              <canvas
                                ref={(el) =>
                                  (canvasRef.current["afterfronttooth"] = el)
                                }
                                style={{ display: "none" }}
                              />
                            </div>
                          )}
                        </div>

                        {webCamStatus[7] && (
                          <div
                            className="d-flex justify-content-between"
                            style={{ width: "170px" }}
                          >
                            <Tooltip title="Capture">
                              <IconButton
                                onClick={() => {
                                  const canvas =
                                    canvasRef.current["afterfronttooth"];
                                  canvas.width = 170;
                                  canvas.height = 115;

                                  const context = canvas.getContext("2d");

                                  context.drawImage(
                                    camRef.current["afterfronttooth"],
                                    0,
                                    0,
                                    canvas.width,
                                    canvas.height
                                  );
                                  const imageSrc =
                                    canvas.toDataURL("image/webp");
                                  setAfterFrontToothPic(imageSrc);
                                  convertToFile(imageSrc, "afterfronttooth");
                                  stopVideoStream("afterfronttooth");
                                  let temp2 = webCamStatus;
                                  temp2[7] = false;
                                  setWebCamStatus([...temp2]);
                                  let temp = [...isHovered];
                                  temp[7] = false;
                                  setIsHovered([...temp]);
                                }}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  class="ionicon"
                                  height="20"
                                  width="20"
                                  viewBox="0 0 512 512"
                                >
                                  <circle cx="256" cy="272" r="64" />
                                  <path d="M432 144h-59c-3 0-6.72-1.94-9.62-5l-25.94-40.94a15.52 15.52 0 00-1.37-1.85C327.11 85.76 315 80 302 80h-92c-13 0-25.11 5.76-34.07 16.21a15.52 15.52 0 00-1.37 1.85l-25.94 41c-2.22 2.42-5.34 5-8.62 5v-8a16 16 0 00-16-16h-24a16 16 0 00-16 16v8h-4a48.05 48.05 0 00-48 48V384a48.05 48.05 0 0048 48h352a48.05 48.05 0 0048-48V192a48.05 48.05 0 00-48-48zM256 368a96 96 0 1196-96 96.11 96.11 0 01-96 96z" />
                                </svg>
                              </IconButton>
                            </Tooltip>

                            <Tooltip title="Switch Camera">
                              <IconButton
                                onClick={() => {
                                  SwitchCamera("afterfronttooth", 7);
                                }}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  class="ionicon"
                                  height="20"
                                  width="20"
                                  viewBox="0 0 512 512"
                                >
                                  <path d="M432 144h-59c-3 0-6.72-1.94-9.62-5l-25.94-40.94a15.52 15.52 0 00-1.37-1.85C327.11 85.76 315 80 302 80h-92c-13 0-25.11 5.76-34.07 16.21a15.52 15.52 0 00-1.37 1.85l-25.94 41c-2.22 2.42-5.34 5-8.62 5v-8a16 16 0 00-16-16h-24a16 16 0 00-16 16v8h-4a48.05 48.05 0 00-48 48V384a48.05 48.05 0 0048 48h352a48.05 48.05 0 0048-48V192a48.05 48.05 0 00-48-48zM316.84 346.3a96.06 96.06 0 01-155.66-59.18 16 16 0 01-16.49-26.43l20-20a16 16 0 0122.62 0l20 20A16 16 0 01196 288a17.31 17.31 0 01-2-.14 64.07 64.07 0 00102.66 33.63 16 16 0 1120.21 24.81zm50.47-63l-20 20a16 16 0 01-22.62 0l-20-20a16 16 0 0113.09-27.2A64 64 0 00215 222.64 16 16 0 11194.61 198a96 96 0 01156 59 16 16 0 0116.72 26.35z" />
                                </svg>
                              </IconButton>
                            </Tooltip>

                            <Tooltip title="Close Camera">
                              <IconButton
                                onClick={() => {
                                  stopVideoStream("afterfronttooth");
                                  let temp2 = webCamStatus;
                                  temp2[7] = false;
                                  setWebCamStatus([...temp2]);
                                }}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  class="ionicon"
                                  height="20"
                                  width="20"
                                  viewBox="0 0 512 512"
                                >
                                  <path d="M289.94 256l95-95A24 24 0 00351 127l-95 95-95-95a24 24 0 00-34 34l95 95-95 95a24 24 0 1034 34l95-95 95 95a24 24 0 0034-34z" />
                                </svg>
                              </IconButton>
                            </Tooltip>
                          </div>
                        )}
                        {!webCamStatus[7] && (
                          <div
                            className="text-center"
                            style={{ width: "170px" }}
                          >
                            Front Tooth
                          </div>
                        )}
                      </div>

                      <div
                        style={{
                          display: screenWidth <= 500 ? "flex" : "",
                          flexDirection: screenWidth <= 500 ? "column" : "",
                          alignItems: screenWidth <= 500 ? "center" : "",
                        }}
                        className="col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4 mt-2 position-relative "
                      >
                        <div
                          id="afterbuccalleft"
                          onMouseEnter={() =>
                            !webCamStatus[8] && handleMouseEnter(8)
                          }
                          onMouseLeave={() =>
                            !webCamStatus[8] && handleMouseLeave(8)
                          }
                          onDrop={handleDrop}
                          className={
                            "border border justify-content-center align-items-center text-center"
                          }
                          onDragOver={(e) => e.preventDefault()}
                          style={{
                            width: "170px",
                            height: "120px",
                            cursor: "pointer",
                            caretColor: "transparent",
                            background:
                              !afterBuccalLeftPic &&
                              `url(${BuccalLeftSVG}) no-repeat center`,
                          }}
                        >
                          {isHovered[8] && (
                            <div
                              className="position-absolute d-flex flex-column align-items-center justify-content-center"
                              style={{
                                width: "160px",
                                height: "110px",
                                top: "1px",
                                backgroundColor: "rgba(256,256,256,0.8)",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-evenly",
                                  width: "-webkit-fill-available",
                                }}
                              >
                                <CiCamera
                                  size={30}
                                  onClick={() => {
                                    let temp = webCamStatus;
                                    temp[8] = true;
                                    setWebCamStatus([...temp]);
                                    let temp2 = [...isHovered];
                                    temp2[8] = false;
                                    setIsHovered([...temp2]);
                                    initializeCamera("afterBuccalLeftPic", 8);
                                  }}
                                />
                                <div
                                  style={{
                                    border: "1px solid rgba(0,0,0,0.1)",
                                    position: "absolute",
                                    height: "108%",
                                    top: "0px",
                                  }}
                                ></div>
                                <IoCloudUploadOutline
                                  size={30}
                                  onClick={() => {
                                    let temp = [...isHovered];
                                    temp[8] = false;
                                    setIsHovered([...temp]);
                                    let temp2 = [...webCamStatus];
                                    temp2[8] = false;
                                    setWebCamStatus([...temp2]);

                                    inputRefBeforeBuccalLeftPic?.current?.click();
                                  }}
                                />
                              </div>
                            </div>
                          )}
                          {imageUploadLoading[8] && afterBuccalLeftPic && (
                            <div
                              className="position-absolute"
                              style={{
                                width: "170px",
                                height: "120px",
                                backgroundColor: "rgba(256,256,256,0.4)",

                                zIndex: 99,
                                top: 0,
                              }}
                            >
                              <div
                                className="position-absolute z-1"
                                style={{ top: 25, left: 65, height: 50 }}
                              >
                                <Loader />
                              </div>
                            </div>
                          )}
                          {
                            <input
                              id="afterbuccalleft"
                              type="file"
                              accept="image/png, image/jpeg"
                              onChange={(event) => handleImageUpload(event)}
                              ref={inputRefAfterBuccalLeftPic}
                              style={{ display: "none" }}
                            />
                          }
                          {!webCamStatus[8] ? (
                            <img
                              src={afterBuccalLeftPic || ""}
                              id="afterbuccalleft"
                              style={{
                                width: "auto",
                                height: "auto",
                                maxHeight: "110px",
                                maxWidth: "160px",
                              }}
                              // alt="buccal left webcam"
                            />
                          ) : (
                            <div>
                              <video
                                ref={(el) =>
                                  (camRef.current["afterbuccalleft"] = el)
                                }
                                autoPlay
                                playsInline
                              />
                              <canvas
                                ref={(el) =>
                                  (canvasRef.current["afterbuccalleft"] = el)
                                }
                                style={{ display: "none" }}
                              />
                            </div>
                          )}
                        </div>

                        {webCamStatus[8] === true && (
                          <div
                            className="d-flex justify-content-between"
                            style={{ width: "170px" }}
                          >
                            <Tooltip title="Capture">
                              <IconButton
                                onClick={() => {
                                  const canvas =
                                    canvasRef.current["afterbuccalleft"];
                                  canvas.width = 170;
                                  canvas.height = 115;

                                  const context = canvas.getContext("2d");

                                  context.drawImage(
                                    camRef.current["afterbuccalleft"],
                                    0,
                                    0,
                                    canvas.width,
                                    canvas.height
                                  );
                                  const imageSrc =
                                    canvas.toDataURL("image/webp");
                                  setAfterBuccalLeftPic(imageSrc);
                                  convertToFile(imageSrc, "afterbuccalleft");
                                  stopVideoStream("afterbuccalleft");
                                  let temp2 = webCamStatus;
                                  temp2[8] = false;
                                  setWebCamStatus([...temp2]);
                                  let temp = [...isHovered];
                                  temp[8] = false;
                                  setIsHovered([...temp]);
                                }}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  class="ionicon"
                                  height="20"
                                  width="20"
                                  viewBox="0 0 512 512"
                                >
                                  <circle cx="256" cy="272" r="64" />
                                  <path d="M432 144h-59c-3 0-6.72-1.94-9.62-5l-25.94-40.94a15.52 15.52 0 00-1.37-1.85C327.11 85.76 315 80 302 80h-92c-13 0-25.11 5.76-34.07 16.21a15.52 15.52 0 00-1.37 1.85l-25.94 41c-2.22 2.42-5.34 5-8.62 5v-8a16 16 0 00-16-16h-24a16 16 0 00-16 16v8h-4a48.05 48.05 0 00-48 48V384a48.05 48.05 0 0048 48h352a48.05 48.05 0 0048-48V192a48.05 48.05 0 00-48-48zM256 368a96 96 0 1196-96 96.11 96.11 0 01-96 96z" />
                                </svg>
                              </IconButton>
                            </Tooltip>

                            <Tooltip title="Switch Camera">
                              <IconButton
                                onClick={() => {
                                  SwitchCamera("afterbuccalleft", 8);
                                }}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  class="ionicon"
                                  height="20"
                                  width="20"
                                  viewBox="0 0 512 512"
                                >
                                  <path d="M432 144h-59c-3 0-6.72-1.94-9.62-5l-25.94-40.94a15.52 15.52 0 00-1.37-1.85C327.11 85.76 315 80 302 80h-92c-13 0-25.11 5.76-34.07 16.21a15.52 15.52 0 00-1.37 1.85l-25.94 41c-2.22 2.42-5.34 5-8.62 5v-8a16 16 0 00-16-16h-24a16 16 0 00-16 16v8h-4a48.05 48.05 0 00-48 48V384a48.05 48.05 0 0048 48h352a48.05 48.05 0 0048-48V192a48.05 48.05 0 00-48-48zM316.84 346.3a96.06 96.06 0 01-155.66-59.18 16 16 0 01-16.49-26.43l20-20a16 16 0 0122.62 0l20 20A16 16 0 01196 288a17.31 17.31 0 01-2-.14 64.07 64.07 0 00102.66 33.63 16 16 0 1120.21 24.81zm50.47-63l-20 20a16 16 0 01-22.62 0l-20-20a16 16 0 0113.09-27.2A64 64 0 00215 222.64 16 16 0 11194.61 198a96 96 0 01156 59 16 16 0 0116.72 26.35z" />
                                </svg>
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Close Camera">
                              <IconButton
                                onClick={() => {
                                  stopVideoStream("afterbuccalleft");
                                  let temp2 = webCamStatus;
                                  temp2[8] = false;
                                  setWebCamStatus([...temp2]);
                                }}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  class="ionicon"
                                  height="20"
                                  width="20"
                                  viewBox="0 0 512 512"
                                >
                                  <path d="M289.94 256l95-95A24 24 0 00351 127l-95 95-95-95a24 24 0 00-34 34l95 95-95 95a24 24 0 1034 34l95-95 95 95a24 24 0 0034-34z" />
                                </svg>
                              </IconButton>
                            </Tooltip>
                          </div>
                        )}
                        {!webCamStatus[8] && (
                          <div
                            className="text-center"
                            style={{ width: "170px" }}
                          >
                            Buccal Left
                          </div>
                        )}
                      </div>

                      <div
                        style={{
                          display: screenWidth <= 500 ? "flex" : "",
                          flexDirection: screenWidth <= 500 ? "column" : "",
                          alignItems: screenWidth <= 500 ? "center" : "",
                        }}
                        className="col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4 mt-2 position-relative "
                      >
                        <div
                          id="afterbuccalright"
                          onMouseEnter={() =>
                            !webCamStatus[9] && handleMouseEnter(9)
                          }
                          onMouseLeave={() =>
                            !webCamStatus[9] && handleMouseLeave(9)
                          }
                          onDrop={handleDrop}
                          className={
                            "border justify-content-center align-items-center text-center"
                          }
                          onDragOver={(e) => e.preventDefault()}
                          style={{
                            width: "170px",
                            height: "120px",
                            cursor: "pointer",
                            caretColor: "transparent",
                            background:
                              !afterBuccalRightPic &&
                              `url(${BuccalRightSVG}) no-repeat center`,
                          }}
                        >
                          {isHovered[9] && (
                            <div
                              className="position-absolute d-flex flex-column align-items-center justify-content-center"
                              style={{
                                width: "160px",
                                height: "110px",
                                top: "1px",
                                backgroundColor: "rgba(256,256,256,0.8)",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-evenly",
                                  width: "-webkit-fill-available",
                                }}
                              >
                                <CiCamera
                                  size={30}
                                  onClick={() => {
                                    let temp = [...webCamStatus];
                                    temp[9] = true;
                                    setWebCamStatus([...temp]);
                                    let temp2 = [...isHovered];
                                    temp2[9] = false;
                                    setIsHovered([...temp2]);
                                    initializeCamera("afterbuccalright", 9);
                                  }}
                                />
                                <div
                                  style={{
                                    border: "1px solid rgba(0,0,0,0.1)",
                                    position: "absolute",
                                    height: "108%",
                                    top: "0px",
                                  }}
                                ></div>
                                <IoCloudUploadOutline
                                  size={30}
                                  onClick={() => {
                                    let temp = [...isHovered];
                                    temp[9] = false;
                                    setIsHovered([...temp]);
                                    let temp2 = [...webCamStatus];
                                    temp2[9] = false;
                                    setWebCamStatus([...temp2]);

                                    inputRefAfterBuccalRightPic?.current?.click();
                                  }}
                                />
                              </div>
                            </div>
                          )}
                          {imageUploadLoading[9] && afterBuccalRightPic && (
                            <div
                              className="position-absolute"
                              style={{
                                width: "170px",
                                height: "120px",
                                backgroundColor: "rgba(256,256,256,0.4)",

                                zIndex: 99,
                                top: 0,
                              }}
                            >
                              <div
                                className="position-absolute z-1"
                                style={{ top: 25, left: 65, height: 50 }}
                              >
                                <Loader />
                              </div>
                            </div>
                          )}
                          {
                            <input
                              id="afterbuccalright"
                              type="file"
                              accept="image/png, image/jpeg"
                              onChange={(event) => handleImageUpload(event)}
                              ref={inputRefAfterBuccalRightPic}
                              style={{ display: "none" }}
                            />
                          }
                          {!webCamStatus[9] ? (
                            <img
                              src={afterBuccalRightPic || ""}
                              id="afterbuccalright"
                              style={{
                                width: "auto",
                                height: "auto",
                                maxHeight: "110px",
                                maxWidth: "160px",
                              }}
                              // alt="buccal right webcam"
                            />
                          ) : (
                            <div>
                              <video
                                ref={(el) =>
                                  (camRef.current["afterbuccalright"] = el)
                                }
                                autoPlay
                                playsInline
                              />
                              <canvas
                                ref={(el) =>
                                  (canvasRef.current["afterbuccalright"] = el)
                                }
                                style={{ display: "none" }}
                              />
                            </div>
                          )}
                        </div>

                        {webCamStatus[9] && (
                          <div
                            className="d-flex justify-content-between"
                            style={{ width: "170px" }}
                          >
                            <Tooltip title="Capture">
                              <IconButton
                                onClick={() => {
                                  const canvas =
                                    canvasRef.current["afterbuccalright"];
                                  canvas.width = 170;
                                  canvas.height = 115;

                                  const context = canvas.getContext("2d");

                                  context.drawImage(
                                    camRef.current["afterbuccalright"],
                                    0,
                                    0,
                                    canvas.width,
                                    canvas.height
                                  );
                                  const imageSrc =
                                    canvas.toDataURL("image/webp");

                                  setAfterBuccalRightPic(imageSrc);
                                  convertToFile(imageSrc, "afterbuccalright");
                                  stopVideoStream("afterbuccalright");
                                  let temp2 = webCamStatus;
                                  temp2[9] = false;
                                  setWebCamStatus([...temp2]);
                                  let temp = [...isHovered];
                                  temp[9] = false;
                                  setIsHovered([...temp]);
                                }}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  class="ionicon"
                                  height="20"
                                  width="20"
                                  viewBox="0 0 512 512"
                                >
                                  <circle cx="256" cy="272" r="64" />
                                  <path d="M432 144h-59c-3 0-6.72-1.94-9.62-5l-25.94-40.94a15.52 15.52 0 00-1.37-1.85C327.11 85.76 315 80 302 80h-92c-13 0-25.11 5.76-34.07 16.21a15.52 15.52 0 00-1.37 1.85l-25.94 41c-2.22 2.42-5.34 5-8.62 5v-8a16 16 0 00-16-16h-24a16 16 0 00-16 16v8h-4a48.05 48.05 0 00-48 48V384a48.05 48.05 0 0048 48h352a48.05 48.05 0 0048-48V192a48.05 48.05 0 00-48-48zM256 368a96 96 0 1196-96 96.11 96.11 0 01-96 96z" />
                                </svg>
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Switch Camera">
                              <IconButton
                                onClick={() => {
                                  SwitchCamera("afterbuccalright", 9);
                                }}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  class="ionicon"
                                  height="20"
                                  width="20"
                                  viewBox="0 0 512 512"
                                >
                                  <path d="M432 144h-59c-3 0-6.72-1.94-9.62-5l-25.94-40.94a15.52 15.52 0 00-1.37-1.85C327.11 85.76 315 80 302 80h-92c-13 0-25.11 5.76-34.07 16.21a15.52 15.52 0 00-1.37 1.85l-25.94 41c-2.22 2.42-5.34 5-8.62 5v-8a16 16 0 00-16-16h-24a16 16 0 00-16 16v8h-4a48.05 48.05 0 00-48 48V384a48.05 48.05 0 0048 48h352a48.05 48.05 0 0048-48V192a48.05 48.05 0 00-48-48zM316.84 346.3a96.06 96.06 0 01-155.66-59.18 16 16 0 01-16.49-26.43l20-20a16 16 0 0122.62 0l20 20A16 16 0 01196 288a17.31 17.31 0 01-2-.14 64.07 64.07 0 00102.66 33.63 16 16 0 1120.21 24.81zm50.47-63l-20 20a16 16 0 01-22.62 0l-20-20a16 16 0 0113.09-27.2A64 64 0 00215 222.64 16 16 0 11194.61 198a96 96 0 01156 59 16 16 0 0116.72 26.35z" />
                                </svg>
                              </IconButton>
                            </Tooltip>

                            <Tooltip title="Close Camera">
                              <IconButton
                                onClick={() => {
                                  stopVideoStream("afterbuccalright");
                                  let temp2 = webCamStatus;
                                  temp2[9] = false;
                                  setWebCamStatus([...temp2]);
                                }}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  class="ionicon"
                                  height="20"
                                  width="20"
                                  viewBox="0 0 512 512"
                                >
                                  <path d="M289.94 256l95-95A24 24 0 00351 127l-95 95-95-95a24 24 0 00-34 34l95 95-95 95a24 24 0 1034 34l95-95 95 95a24 24 0 0034-34z" />
                                </svg>
                              </IconButton>
                            </Tooltip>
                          </div>
                        )}
                        {!webCamStatus[9] && (
                          <div
                            className="text-center"
                            style={{ width: "170px" }}
                          >
                            Buccal Right
                          </div>
                        )}
                      </div>

                      <div
                        style={{
                          display: screenWidth <= 500 ? "flex" : "",
                          flexDirection: screenWidth <= 500 ? "column" : "",
                          alignItems: screenWidth <= 500 ? "center" : "",
                        }}
                        className="col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4 mt-2 position-relative "
                      >
                        <div
                          id="afterocclusalupper"
                          onMouseEnter={() =>
                            !webCamStatus[10] && handleMouseEnter(10)
                          }
                          onMouseLeave={() =>
                            !webCamStatus[10] && handleMouseLeave(10)
                          }
                          onDrop={handleDrop}
                          className={
                            "border justify-content-center align-items-center text-center"
                          }
                          onDragOver={(e) => e.preventDefault()}
                          style={{
                            width: "170px",
                            height: "120px",
                            cursor: "pointer",
                            caretColor: "transparent",
                            background:
                              !afterOcclusalUpperPic &&
                              `url(${OcclusalUpperSVG}) no-repeat center`,
                          }}
                        >
                          {isHovered[10] && (
                            <div
                              className="position-absolute d-flex flex-column align-items-center justify-content-center"
                              style={{
                                width: "160px",
                                height: "110px",
                                top: "1px",
                                backgroundColor: "rgba(256,256,256,0.8)",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-evenly",
                                  width: "-webkit-fill-available",
                                }}
                              >
                                <CiCamera
                                  size={30}
                                  onClick={() => {
                                    let temp = webCamStatus;
                                    temp[10] = true;
                                    setWebCamStatus([...temp]);
                                    let temp2 = [...isHovered];
                                    temp2[10] = false;
                                    setIsHovered([...temp2]);
                                    initializeCamera("afterocclusalupper", 10);
                                  }}
                                />
                                <div
                                  style={{
                                    border: "1px solid rgba(0,0,0,0.1)",
                                    position: "absolute",
                                    height: "108%",
                                    top: "0px",
                                  }}
                                ></div>
                                <IoCloudUploadOutline
                                  size={30}
                                  onClick={() => {
                                    let temp = [...isHovered];
                                    temp[10] = false;
                                    setIsHovered([...temp]);
                                    let temp2 = [...webCamStatus];
                                    temp2[10] = false;
                                    setWebCamStatus([...temp2]);

                                    inputRefAfterOcclusalUpperPic?.current?.click();
                                  }}
                                />
                              </div>
                            </div>
                          )}
                          {imageUploadLoading[10] && afterOcclusalUpperPic && (
                            <div
                              className="position-absolute"
                              style={{
                                width: "170px",
                                height: "120px",
                                backgroundColor: "rgba(256,256,256,0.4)",

                                zIndex: 99,
                                top: 0,
                              }}
                            >
                              <div
                                className="position-absolute z-1"
                                style={{ top: 25, left: 65, height: 50 }}
                              >
                                <Loader />
                              </div>
                            </div>
                          )}
                          {
                            <input
                              id="afterocclusalupper"
                              type="file"
                              accept="image/png, image/jpeg"
                              onChange={(event) => handleImageUpload(event)}
                              ref={inputRefAfterBuccalRightPic}
                              style={{ display: "none" }}
                            />
                          }
                          {!webCamStatus[10] ? (
                            <img
                              src={afterOcclusalUpperPic || ""}
                              id="afterocclusalupper"
                              style={{
                                width: "auto",
                                height: "auto",
                                maxHeight: "110px",
                                maxWidth: "160px",
                              }}
                              // alt="occlusal upper webcam"
                            />
                          ) : (
                            <div>
                              <video
                                ref={(el) =>
                                  (camRef.current["afterocclusalupper"] = el)
                                }
                                autoPlay
                                playsInline
                              />
                              <canvas
                                ref={(el) =>
                                  (canvasRef.current["afterocclusalupper"] = el)
                                }
                                style={{ display: "none" }}
                              />
                            </div>
                          )}
                        </div>

                        {webCamStatus[10] && (
                          <div
                            className="d-flex justify-content-between"
                            style={{ width: "170px" }}
                          >
                            <Tooltip title="Capture">
                              <IconButton
                                onClick={() => {
                                  const canvas =
                                    canvasRef.current["afterocclusalupper"];
                                  canvas.width = 170;
                                  canvas.height = 115;

                                  const context = canvas.getContext("2d");

                                  context.drawImage(
                                    camRef.current["afterocclusalupper"],
                                    0,
                                    0,
                                    canvas.width,
                                    canvas.height
                                  );
                                  const imageSrc =
                                    canvas.toDataURL("image/webp");
                                  setAfterOcclusalUpperPic(imageSrc);
                                  convertToFile(imageSrc, "afterocclusalupper");

                                  stopVideoStream("afterocclusalupper");
                                  let temp2 = webCamStatus;
                                  temp2[10] = false;
                                  setWebCamStatus([...temp2]);
                                  let temp = [...isHovered];
                                  temp[10] = false;
                                  setIsHovered([...temp]);
                                }}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  class="ionicon"
                                  height="20"
                                  width="20"
                                  viewBox="0 0 512 512"
                                >
                                  <circle cx="256" cy="272" r="64" />
                                  <path d="M432 144h-59c-3 0-6.72-1.94-9.62-5l-25.94-40.94a15.52 15.52 0 00-1.37-1.85C327.11 85.76 315 80 302 80h-92c-13 0-25.11 5.76-34.07 16.21a15.52 15.52 0 00-1.37 1.85l-25.94 41c-2.22 2.42-5.34 5-8.62 5v-8a16 16 0 00-16-16h-24a16 16 0 00-16 16v8h-4a48.05 48.05 0 00-48 48V384a48.05 48.05 0 0048 48h352a48.05 48.05 0 0048-48V192a48.05 48.05 0 00-48-48zM256 368a96 96 0 1196-96 96.11 96.11 0 01-96 96z" />
                                </svg>
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Switch Camera">
                              <IconButton
                                onClick={() => {
                                  SwitchCamera("afterocclusalupper", 10);
                                }}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  class="ionicon"
                                  height="20"
                                  width="20"
                                  viewBox="0 0 512 512"
                                >
                                  <path d="M432 144h-59c-3 0-6.72-1.94-9.62-5l-25.94-40.94a15.52 15.52 0 00-1.37-1.85C327.11 85.76 315 80 302 80h-92c-13 0-25.11 5.76-34.07 16.21a15.52 15.52 0 00-1.37 1.85l-25.94 41c-2.22 2.42-5.34 5-8.62 5v-8a16 16 0 00-16-16h-24a16 16 0 00-16 16v8h-4a48.05 48.05 0 00-48 48V384a48.05 48.05 0 0048 48h352a48.05 48.05 0 0048-48V192a48.05 48.05 0 00-48-48zM316.84 346.3a96.06 96.06 0 01-155.66-59.18 16 16 0 01-16.49-26.43l20-20a16 16 0 0122.62 0l20 20A16 16 0 01196 288a17.31 17.31 0 01-2-.14 64.07 64.07 0 00102.66 33.63 16 16 0 1120.21 24.81zm50.47-63l-20 20a16 16 0 01-22.62 0l-20-20a16 16 0 0113.09-27.2A64 64 0 00215 222.64 16 16 0 11194.61 198a96 96 0 01156 59 16 16 0 0116.72 26.35z" />
                                </svg>
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Close Camera">
                              <IconButton
                                onClick={() => {
                                  stopVideoStream("afterocclusalupper");
                                  let temp2 = webCamStatus;
                                  temp2[10] = false;
                                  setWebCamStatus([...temp2]);
                                }}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  class="ionicon"
                                  height="20"
                                  width="20"
                                  viewBox="0 0 512 512"
                                >
                                  <path d="M289.94 256l95-95A24 24 0 00351 127l-95 95-95-95a24 24 0 00-34 34l95 95-95 95a24 24 0 1034 34l95-95 95 95a24 24 0 0034-34z" />
                                </svg>
                              </IconButton>
                            </Tooltip>
                          </div>
                        )}
                        {!webCamStatus[10] && (
                          <div
                            className="text-center"
                            style={{ width: "170px" }}
                          >
                            Occlusal Upper
                          </div>
                        )}
                      </div>

                      <div
                        style={{
                          display: screenWidth <= 500 ? "flex" : "",
                          flexDirection: screenWidth <= 500 ? "column" : "",
                          alignItems: screenWidth <= 500 ? "center" : "",
                        }}
                        className="col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4 mt-2 position-relative "
                      >
                        <div
                          id="afterocclusallower"
                          onMouseEnter={() =>
                            !webCamStatus[11] && handleMouseEnter(11)
                          }
                          onMouseLeave={() =>
                            !webCamStatus[11] && handleMouseLeave(11)
                          }
                          onDrop={handleDrop}
                          className={
                            "border justify-content-center align-items-center text-center"
                          }
                          onDragOver={(e) => e.preventDefault()}
                          style={{
                            width: "170px",
                            height: "120px",
                            cursor: "pointer",
                            caretColor: "transparent",
                            background:
                              !afterOcclusalLowerPic &&
                              `url(${OcclusalLowerSVG}) no-repeat center`,
                          }}
                        >
                          {isHovered[11] && (
                            <div
                              className="position-absolute d-flex flex-column align-items-center justify-content-center"
                              style={{
                                width: "160px",
                                height: "110px",
                                top: "1px",
                                backgroundColor: "rgba(256,256,256,0.8)",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-evenly",
                                  width: "-webkit-fill-available",
                                }}
                              >
                                <CiCamera
                                  size={30}
                                  onClick={() => {
                                    let temp = webCamStatus;
                                    temp[11] = true;
                                    setWebCamStatus([...temp]);
                                    let temp2 = [...isHovered];
                                    temp2[11] = false;
                                    setIsHovered([...temp2]);
                                    initializeCamera("afterocclusallower", 11);
                                  }}
                                />
                                <div
                                  style={{
                                    border: "1px solid rgba(0,0,0,0.1)",
                                    position: "absolute",
                                    height: "108%",
                                    top: "0px",
                                  }}
                                ></div>
                                <IoCloudUploadOutline
                                  size={30}
                                  onClick={() => {
                                    let temp = [...isHovered];
                                    temp[11] = false;
                                    setIsHovered([...temp]);
                                    let temp2 = [...webCamStatus];
                                    temp2[11] = false;
                                    setWebCamStatus([...temp2]);

                                    inputRefAfterOcclusalLowerPic?.current?.click();
                                  }}
                                />
                              </div>
                            </div>
                          )}
                          {imageUploadLoading[11] && afterOcclusalLowerPic && (
                            <div
                              className="position-absolute"
                              style={{
                                width: "170px",
                                height: "120px",
                                backgroundColor: "rgba(256,256,256,0.4)",

                                zIndex: 99,
                                top: 0,
                              }}
                            >
                              <div
                                className="position-absolute z-1"
                                style={{ top: 25, left: 65, height: 50 }}
                              >
                                <Loader />
                              </div>
                            </div>
                          )}
                          {
                            <input
                              id="afterocclusallower"
                              type="file"
                              accept="image/png, image/jpeg"
                              onChange={(event) => handleImageUpload(event)}
                              ref={inputRefAfterOcclusalLowerPic}
                              style={{ display: "none" }}
                            />
                          }
                          {!webCamStatus[11] ? (
                            <img
                              src={afterOcclusalLowerPic || ""}
                              id="afterocclusallower"
                              style={{
                                width: "auto",
                                height: "auto",
                                maxHeight: "110px",
                                maxWidth: "160px",
                              }}
                              // alt="occlual lower webcam"
                            />
                          ) : (
                            <div>
                              <video
                                ref={(el) =>
                                  (camRef.current["afterocclusallower"] = el)
                                }
                                autoPlay
                                playsInline
                              />
                              <canvas
                                ref={(el) =>
                                  (canvasRef.current["afterocclusallower"] = el)
                                }
                                style={{ display: "none" }}
                              />
                            </div>
                          )}
                        </div>

                        {webCamStatus[11] && (
                          <div
                            className="d-flex justify-content-between"
                            style={{ width: "170px" }}
                          >
                            <Tooltip title="Capture">
                              <IconButton
                                onClick={() => {
                                  const canvas =
                                    canvasRef.current["afterocclusallower"];
                                  canvas.width = 170;
                                  canvas.height = 115;

                                  const context = canvas.getContext("2d");

                                  context.drawImage(
                                    camRef.current["afterocclusallower"],
                                    0,
                                    0,
                                    canvas.width,
                                    canvas.height
                                  );
                                  const imageSrc =
                                    canvas.toDataURL("image/webp");
                                  setAfterOcclusalLowerPic(imageSrc);
                                  convertToFile(imageSrc, "afterocclusallower");

                                  stopVideoStream("afterocclusallower");
                                  let temp2 = webCamStatus;
                                  temp2[11] = false;
                                  setWebCamStatus([...temp2]);
                                  let temp = [...isHovered];
                                  temp[11] = false;
                                  setIsHovered([...temp]);
                                }}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  class="ionicon"
                                  height="20"
                                  width="20"
                                  viewBox="0 0 512 512"
                                >
                                  <circle cx="256" cy="272" r="64" />
                                  <path d="M432 144h-59c-3 0-6.72-1.94-9.62-5l-25.94-40.94a15.52 15.52 0 00-1.37-1.85C327.11 85.76 315 80 302 80h-92c-13 0-25.11 5.76-34.07 16.21a15.52 15.52 0 00-1.37 1.85l-25.94 41c-2.22 2.42-5.34 5-8.62 5v-8a16 16 0 00-16-16h-24a16 16 0 00-16 16v8h-4a48.05 48.05 0 00-48 48V384a48.05 48.05 0 0048 48h352a48.05 48.05 0 0048-48V192a48.05 48.05 0 00-48-48zM256 368a96 96 0 1196-96 96.11 96.11 0 01-96 96z" />
                                </svg>
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Switch Camera">
                              <IconButton
                                onClick={() => {
                                  SwitchCamera("afterocclusallower", 11);
                                }}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  class="ionicon"
                                  height="20"
                                  width="20"
                                  viewBox="0 0 512 512"
                                >
                                  <path d="M432 144h-59c-3 0-6.72-1.94-9.62-5l-25.94-40.94a15.52 15.52 0 00-1.37-1.85C327.11 85.76 315 80 302 80h-92c-13 0-25.11 5.76-34.07 16.21a15.52 15.52 0 00-1.37 1.85l-25.94 41c-2.22 2.42-5.34 5-8.62 5v-8a16 16 0 00-16-16h-24a16 16 0 00-16 16v8h-4a48.05 48.05 0 00-48 48V384a48.05 48.05 0 0048 48h352a48.05 48.05 0 0048-48V192a48.05 48.05 0 00-48-48zM316.84 346.3a96.06 96.06 0 01-155.66-59.18 16 16 0 01-16.49-26.43l20-20a16 16 0 0122.62 0l20 20A16 16 0 01196 288a17.31 17.31 0 01-2-.14 64.07 64.07 0 00102.66 33.63 16 16 0 1120.21 24.81zm50.47-63l-20 20a16 16 0 01-22.62 0l-20-20a16 16 0 0113.09-27.2A64 64 0 00215 222.64 16 16 0 11194.61 198a96 96 0 01156 59 16 16 0 0116.72 26.35z" />
                                </svg>
                              </IconButton>
                            </Tooltip>

                            <Tooltip title="Close Camera">
                              <IconButton
                                onClick={() => {
                                  stopVideoStream("beforeocclusallower");
                                  let temp2 = webCamStatus;
                                  temp2[11] = false;
                                  setWebCamStatus([...temp2]);
                                }}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  class="ionicon"
                                  height="20"
                                  width="20"
                                  viewBox="0 0 512 512"
                                >
                                  <path d="M289.94 256l95-95A24 24 0 00351 127l-95 95-95-95a24 24 0 00-34 34l95 95-95 95a24 24 0 1034 34l95-95 95 95a24 24 0 0034-34z" />
                                </svg>
                              </IconButton>
                            </Tooltip>
                          </div>
                        )}
                        {!webCamStatus[11] && (
                          <div
                            className="text-center"
                            style={{ width: "170px" }}
                          >
                            Occlusal Lower
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* BOTTOM SECTION */}
          <div className="col-12 p-0">
            <div
              className="row w-100 mx-auto flex-column align-items-center justify-content-start"
              style={{
                gap: "16px",
              }}
            >
              <div className="col-auto p-0">
                <div
                  className="text-center"
                  style={{
                    fontSize: "12px",
                    color: PRIMARY_COLOR,
                    fontWeight: "normal",
                    lineHeight: "1",
                  }}
                >
                  {/* Alignment Switch History */}
                  Aligner Switch History
                </div>
              </div>

              <div
                className={`${screenWidth > 620 ? "col-8" : "col-auto"} p-0`}
              >
                <div
                  className="w-100 d-flex flex-column justify-content-start"
                  style={{
                    minHeight: "125px",
                    paddingInline: "8px",
                  }}
                >
                  <div
                    className="row w-100 mx-auto flex-column justify-content-between align-items-start"
                    style={{
                      color: "rgb(110, 121, 125)",
                      gap: "22px",
                    }}
                  >
                    {Array.from({ length: Math.max(
                       Math.max(
                        alignerData?.aligners_lower_quantity,
                        alignerData?.aligners_upper_quantity
                      ) +
                      Math.max(
                        alignerData?.retainer_lower_quantity,
                        alignerData?.retainer_upper_quantity
                      )
                    ) }).map(
                      (item, index) => {
                        let IconComponent =
                          index + 1 < alignerData?.before_aligner_pictures?.length
                            ? FaCircleCheck
                            : PlusIconPrimary;

                        return (
                          <div className="col-12 p-0" key={index}>
                            <div
                              className={`row w-100 mx-auto align-items-center justify-content-${
                                screenWidth > 620 ? "between" : "start"
                              }`}
                              style={{
                                gap: "7px",
                              }}
                            >
                              <div className="d-flex col-auto px-0 gap-md-4 gap-2">
                                <div className="col-auto p-0 position-relative">
                                  {index !==  Math.max(
                       Math.max(
                        alignerData?.aligners_lower_quantity,
                        alignerData?.aligners_upper_quantity
                      ) +
                      Math.max(
                        alignerData?.retainer_lower_quantity,
                        alignerData?.retainer_upper_quantity
                      )
                    ) - 1 && (
                                    <div
                                      className="position-absolute"
                                      style={{
                                        width: "0.8px",
                                        height: "20px",
                                        backgroundColor: "rgb(176, 176, 176)",
                                        bottom: "0",
                                        left: "47%",
                                        transform:
                                          "translateY(112%) translateX(0%)",
                                      }}
                                    ></div>
                                  )}
                                  <div
                                    className="d-flex align-items-center justify-content-center"
                                    style={{
                                      // height: '21px',
                                      width: "21px",
                                    }}
                                  >
                                    <IconComponent
                                      style={
                                        index + 1 < alignerData?.before_aligner_pictures?.length
                                          ? {
                                              color: CHECK_ICON_COLOR,
                                              height: "100%",
                                              width: "100%",
                                              overflow: "visible",
                                            }
                                          : {
                                              fill: PRIMARY_COLOR,
                                              height: "100%",
                                              width: "100%",
                                              overflow: "visible",
                                            }
                                      }
                                    />
                                  </div>
                                </div>
                                {/* <div className="col-auto p-0">
                                  <div
                                    className="row w-100 mx-auto flex-column align-items-center justify-content-center"
                                    style={{
                                      lineHeight: "1",
                                      minWidth: "45px",
                                      gap: "3px",
                                      color: TEXT_COLOR,
                                    }}
                                  >
                                    <div className="col-auto p-0">
                                      <div
                                        className=""
                                        style={{
                                          fontSize: "12px",
                                        }}
                                      >
                                        {item?.date}
                                      </div>
                                    </div>
                                    <div className="col-auto p-0">
                                      <div
                                        className=""
                                        style={{
                                          fontSize: "8.5px",
                                        }}
                                      >
                                        {item?.time}
                                      </div>
                                    </div>
                                  </div>
                                </div> */}
                              </div>
                              <div
                                className={`${
                                  screenWidth > 620 ? "col-auto" : "col"
                                } p-0`}
                              >
                                <div
                                  className="row w-100 mx-auto flex-column align-items-start justify-content-center"
                                  style={{
                                    lineHeight: "1",
                                    // minWidth: '80px',
                                    gap: "3px",
                                    // textDecoration: 'underline'
                                  }}
                                >
                                  <div className="col-auto p-0">
                                    <div
                                      className=""
                                      style={{
                                        fontSize: "12px",
                                        // textDecoration: 'underline',
                                        // textDecorationThickness: '0.06em'
                                      }}
                                    >
                                      {/* {item?.title} */}
                                      {index < alignerMax
                                        ? `Aligner ${index + 1}`
                                        : `Retainer ${index - alignerMax + 1}`}
                                    </div>
                                  </div>
                                  <div className="col-auto p-0">
                                    <div
                                      className=""
                                      style={{
                                        fontSize: "8.5px",
                                        // textDecoration: 'underline',
                                        // textDecorationThickness: '0.1em'
                                      }}
                                    >
                                      Status:{" "}
                                      {index + 1 > alignerData?.before_aligner_pictures.length
                                        ? `Pending`
                                        : `Switched`}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      }
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            className={`col-12 ${screenWidth > 620 ? "" : "col-sm-auto"} p-0`}
          >
            <div
              className="row w-100 mx-auto flex-column align-items-center justify-content-start"
              style={{
                gap: "18px",
              }}
            >
              <div className="col-auto p-0">
                <div
                  className="text-center"
                  style={{
                    fontSize: "12px",
                    color: PRIMARY_COLOR,
                    fontWeight: "normal",
                    lineHeight: "1",
                  }}
                >
                  Case History
                </div>
              </div>

              {caseHistory &&
                caseHistory.length > 0 &&
                caseHistory.map((item) => (
                  <div
                    className="row w-100 mx-auto align-items-center justify-content-start"
                    style={{
                      gap: "22px",
                      minHeight: "70px",
                    }}
                  >
                    <div
                      className="row w-100 mx-auto align-items-center justify-content-center"
                      style={{
                        backgroundColor: "rgb(255, 255, 255)",
                        borderRadius: "15px",
                        // padding: '6px',
                      }}
                    >
                      <div
                        className={`${
                          screenWidth > 620 ? "col-8" : "col-auto"
                        } p-0`}
                      >
                        <div
                          className={`row w-100 mx-auto align-items-start justify-content-${
                            screenWidth > 620 ? "between" : "start"
                          }`}
                          style={{
                            gap: "16px",
                            flexWrap: "nowrap",
                          }}
                        >
                          <div className="d-flex col-auto p-0 gap-3">
                            <div className="col-auto p-0">
                              <div
                                className="row w-100 mx-auto flex-column align-items-center justify-content-center"
                                style={{
                                  gap: "6px",
                                }}
                              >
                                <div className="col-auto p-0">
                                  <div
                                    className=""
                                    style={{
                                      width: "37px",
                                    }}
                                  >
                                    <ClockIcon
                                      style={{
                                        overflow: "visible",
                                      }}
                                    />
                                  </div>
                                </div>

                                <div className="col-auto p-0">
                                  <div
                                    className=""
                                    style={{
                                      lineHeight: "1",
                                      fontSize: "10px",
                                      color: DESCRIPTION_COLOR,
                                      fontWeight: "normal",
                                    }}
                                  >
                                    {item?.case_submit_date ? moment(item?.case_submit_date).format(
                                      "hh:mm A"
                                    ) : ''}
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="col-auto p-0">
                              <div
                                className="row w-100 mx-auto flex-column align-items-center justify-content-center"
                                style={{
                                  lineHeight: "1",
                                }}
                              >
                                <div className="col-auto p-0">
                                  <div
                                    className=""
                                    style={{
                                      fontSize: "22px",
                                      color: PRIMARY_COLOR,
                                      fontWeight: "normal",
                                    }}
                                  >
                                    {item?.case_submit_date ? moment(item?.case_submit_date).format(
                                      "DD"
                                    ) : ''}
                                  </div>
                                </div>
                                <div
                                  className="col-auto p-0"
                                  style={{
                                    marginTop: "2.5px",
                                  }}
                                >
                                  <div
                                    className=""
                                    style={{
                                      fontSize: "14.5px",
                                      color: "#000000",
                                      fontWeight: "normal",
                                    }}
                                  >
                                     {item?.case_submit_date ? moment(item?.case_submit_date).format(
                                      "MMM"
                                    ) : ''}
                                  </div>
                                </div>
                                <div
                                  className="col-auto p-0"
                                  style={{
                                    marginTop: "1px",
                                  }}
                                >
                                  <div
                                    className=""
                                    style={{
                                      fontSize: "10px",
                                      color: DESCRIPTION_COLOR,
                                      fontWeight: "normal",
                                    }}
                                  >
                                    {item?.case_submit_date ? moment(item?.case_submit_date).format(
                                      "YYYY"
                                    ) : ''}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="col-auto p-0">
                            <div
                              className="row w-100 mx-auto flex-column align-items-start justify-content-start"
                              style={{
                                gap: "8px",
                                paddingTop: "2px",
                              }}
                            >
                              <div className="col-auto p-0">
                                <div
                                  className="row w-100 mx-auto flex-column align-items-start"
                                  style={{
                                    lineHeight: "1",
                                    fontWeight: "normal",
                                    gap: "0.5px",
                                  }}
                                >
                                  <div className="col-auto p-0">
                                    <div
                                      className=""
                                      style={{
                                        fontSize: "9px",
                                        color: DESCRIPTION_COLOR,
                                      }}
                                    >
                                      {/* Treatment */}
                                      Service
                                    </div>
                                  </div>

                                  <div className="col-auto p-0">
                                    <div
                                      className=""
                                      style={{
                                        fontSize: "10px",
                                        color: PRIMARY_COLOR,
                                        minWidth: "125px",
                                        maxWidth: "150px",
                                      }}
                                    >
                                      {/* Root Canal Treatment */}
                                      {item?.service && item?.service === "both"
                                ? "TP / FAB"
                                : item?.service.toUpperCase()}
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="col-auto p-0">
                                <div
                                  className="row w-100 mx-auto flex-column align-items-start"
                                  style={{
                                    lineHeight: "1",
                                    fontWeight: "normal",
                                    gap: "0.5px",
                                  }}
                                >
                                  <div className="col-auto p-0">
                                    <div
                                      className=""
                                      style={{
                                        fontSize: "9px",
                                        color: DESCRIPTION_COLOR,
                                      }}
                                    >
                                      Doctor
                                    </div>
                                  </div>

                                  <div className="col-auto p-0">
                                    <div
                                      className=""
                                      style={{
                                        fontSize: "10px",
                                        color: PRIMARY_COLOR,
                                        minWidth: "125px",
                                        maxWidth: "150px",
                                      }}
                                    >
                                      {/* Adam Jacob - Dentora */}
                                      {item?.doctor_name}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SwitchAlignersScreen;
